import { defineComponent as ae, resolveComponent as Le, createElementBlock as P, openBlock as _, Fragment as ne, createElementVNode as F, createVNode as x, mergeProps as dt, withModifiers as lo, normalizeClass as Z, createBlock as pe, createCommentVNode as Q, Transition as xa, withCtx as ee, normalizeStyle as Lt, renderList as we, renderSlot as Wt, unref as y, resolveDynamicComponent as Fa, normalizeProps as xt, toRef as nr, toDisplayString as me, computed as m, withKeys as Yn, withDirectives as Ra, ref as G, onMounted as gr, onUnmounted as Qr, watch as fe, watchEffect as Ha, provide as jt, inject as Bt, createTextVNode as en, reactive as tn, toRefs as uo, resolveDirective as co, toHandlers as fo, nextTick as At, guardReactiveProps as jr, isRef as Ct } from "vue";
import { c as vo } from "./popper-BDAJHTVh.mjs";
var ho = Object.defineProperty, mo = (e, t, r) => t in e ? ho(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, k = (e, t, r) => (mo(e, typeof t != "symbol" ? t + "" : t, r), r), er = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Wa(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var po = Object.prototype, yo = po.hasOwnProperty;
function go(e, t) {
  return e != null && yo.call(e, t);
}
var bo = go, Do = Array.isArray, Ye = Do, wo = typeof er == "object" && er && er.Object === Object && er, ja = wo, $o = ja, _o = typeof self == "object" && self && self.Object === Object && self, Mo = $o || _o || Function("return this")(), Se = Mo, ko = Se, Yo = ko.Symbol, br = Yo, Pn = br, Ba = Object.prototype, Po = Ba.hasOwnProperty, To = Ba.toString, Ot = Pn ? Pn.toStringTag : void 0;
function Co(e) {
  var t = Po.call(e, Ot), r = e[Ot];
  try {
    e[Ot] = void 0;
    var n = !0;
  } catch {
  }
  var a = To.call(e);
  return n && (t ? e[Ot] = r : delete e[Ot]), a;
}
var Oo = Co, So = Object.prototype, Io = So.toString;
function Ao(e) {
  return Io.call(e);
}
var Eo = Ao, Tn = br, No = Oo, Lo = Eo, xo = "[object Null]", Fo = "[object Undefined]", Cn = Tn ? Tn.toStringTag : void 0;
function Ro(e) {
  return e == null ? e === void 0 ? Fo : xo : Cn && Cn in Object(e) ? No(e) : Lo(e);
}
var Ie = Ro;
function Ho(e) {
  return e != null && typeof e == "object";
}
var Pe = Ho, Wo = Ie, jo = Pe, Bo = "[object Symbol]";
function zo(e) {
  return typeof e == "symbol" || jo(e) && Wo(e) == Bo;
}
var rn = zo, Uo = Ye, Vo = rn, Ko = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Go = /^\w*$/;
function Zo(e, t) {
  if (Uo(e))
    return !1;
  var r = typeof e;
  return r == "number" || r == "symbol" || r == "boolean" || e == null || Vo(e) ? !0 : Go.test(e) || !Ko.test(e) || t != null && e in Object(t);
}
var nn = Zo;
function qo(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var He = qo, Xo = Ie, Jo = He, Qo = "[object AsyncFunction]", ei = "[object Function]", ti = "[object GeneratorFunction]", ri = "[object Proxy]";
function ni(e) {
  if (!Jo(e))
    return !1;
  var t = Xo(e);
  return t == ei || t == ti || t == Qo || t == ri;
}
var Qe = ni, ai = Se, si = ai["__core-js_shared__"], oi = si, Er = oi, On = function() {
  var e = /[^.]+$/.exec(Er && Er.keys && Er.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function ii(e) {
  return !!On && On in e;
}
var li = ii, ui = Function.prototype, ci = ui.toString;
function di(e) {
  if (e != null) {
    try {
      return ci.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var za = di, fi = Qe, vi = li, hi = He, mi = za, pi = /[\\^$.*+?()[\]{}|]/g, yi = /^\[object .+?Constructor\]$/, gi = Function.prototype, bi = Object.prototype, Di = gi.toString, wi = bi.hasOwnProperty, $i = RegExp(
  "^" + Di.call(wi).replace(pi, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function _i(e) {
  if (!hi(e) || vi(e))
    return !1;
  var t = fi(e) ? $i : yi;
  return t.test(mi(e));
}
var Mi = _i;
function ki(e, t) {
  return e == null ? void 0 : e[t];
}
var Yi = ki, Pi = Mi, Ti = Yi;
function Ci(e, t) {
  var r = Ti(e, t);
  return Pi(r) ? r : void 0;
}
var et = Ci, Oi = et, Si = Oi(Object, "create"), Dr = Si, Sn = Dr;
function Ii() {
  this.__data__ = Sn ? Sn(null) : {}, this.size = 0;
}
var Ai = Ii;
function Ei(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var Ni = Ei, Li = Dr, xi = "__lodash_hash_undefined__", Fi = Object.prototype, Ri = Fi.hasOwnProperty;
function Hi(e) {
  var t = this.__data__;
  if (Li) {
    var r = t[e];
    return r === xi ? void 0 : r;
  }
  return Ri.call(t, e) ? t[e] : void 0;
}
var Wi = Hi, ji = Dr, Bi = Object.prototype, zi = Bi.hasOwnProperty;
function Ui(e) {
  var t = this.__data__;
  return ji ? t[e] !== void 0 : zi.call(t, e);
}
var Vi = Ui, Ki = Dr, Gi = "__lodash_hash_undefined__";
function Zi(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = Ki && t === void 0 ? Gi : t, this;
}
var qi = Zi, Xi = Ai, Ji = Ni, Qi = Wi, el = Vi, tl = qi;
function ft(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
ft.prototype.clear = Xi;
ft.prototype.delete = Ji;
ft.prototype.get = Qi;
ft.prototype.has = el;
ft.prototype.set = tl;
var rl = ft;
function nl() {
  this.__data__ = [], this.size = 0;
}
var al = nl;
function sl(e, t) {
  return e === t || e !== e && t !== t;
}
var vt = sl, ol = vt;
function il(e, t) {
  for (var r = e.length; r--; )
    if (ol(e[r][0], t))
      return r;
  return -1;
}
var wr = il, ll = wr, ul = Array.prototype, cl = ul.splice;
function dl(e) {
  var t = this.__data__, r = ll(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : cl.call(t, r, 1), --this.size, !0;
}
var fl = dl, vl = wr;
function hl(e) {
  var t = this.__data__, r = vl(t, e);
  return r < 0 ? void 0 : t[r][1];
}
var ml = hl, pl = wr;
function yl(e) {
  return pl(this.__data__, e) > -1;
}
var gl = yl, bl = wr;
function Dl(e, t) {
  var r = this.__data__, n = bl(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
var wl = Dl, $l = al, _l = fl, Ml = ml, kl = gl, Yl = wl;
function ht(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
ht.prototype.clear = $l;
ht.prototype.delete = _l;
ht.prototype.get = Ml;
ht.prototype.has = kl;
ht.prototype.set = Yl;
var $r = ht, Pl = et, Tl = Se, Cl = Pl(Tl, "Map"), an = Cl, In = rl, Ol = $r, Sl = an;
function Il() {
  this.size = 0, this.__data__ = {
    hash: new In(),
    map: new (Sl || Ol)(),
    string: new In()
  };
}
var Al = Il;
function El(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var Nl = El, Ll = Nl;
function xl(e, t) {
  var r = e.__data__;
  return Ll(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
var _r = xl, Fl = _r;
function Rl(e) {
  var t = Fl(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var Hl = Rl, Wl = _r;
function jl(e) {
  return Wl(this, e).get(e);
}
var Bl = jl, zl = _r;
function Ul(e) {
  return zl(this, e).has(e);
}
var Vl = Ul, Kl = _r;
function Gl(e, t) {
  var r = Kl(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
var Zl = Gl, ql = Al, Xl = Hl, Jl = Bl, Ql = Vl, eu = Zl;
function mt(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
mt.prototype.clear = ql;
mt.prototype.delete = Xl;
mt.prototype.get = Jl;
mt.prototype.has = Ql;
mt.prototype.set = eu;
var sn = mt, Ua = sn, tu = "Expected a function";
function on(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(tu);
  var r = function() {
    var n = arguments, a = t ? t.apply(this, n) : n[0], s = r.cache;
    if (s.has(a))
      return s.get(a);
    var o = e.apply(this, n);
    return r.cache = s.set(a, o) || s, o;
  };
  return r.cache = new (on.Cache || Ua)(), r;
}
on.Cache = Ua;
var ru = on, nu = ru, au = 500;
function su(e) {
  var t = nu(e, function(n) {
    return r.size === au && r.clear(), n;
  }), r = t.cache;
  return t;
}
var ou = su, iu = ou, lu = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, uu = /\\(\\)?/g, cu = iu(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(lu, function(r, n, a, s) {
    t.push(a ? s.replace(uu, "$1") : n || r);
  }), t;
}), du = cu;
function fu(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, a = Array(n); ++r < n; )
    a[r] = t(e[r], r, e);
  return a;
}
var vu = fu, An = br, hu = vu, mu = Ye, pu = rn, En = An ? An.prototype : void 0, Nn = En ? En.toString : void 0;
function Va(e) {
  if (typeof e == "string")
    return e;
  if (mu(e))
    return hu(e, Va) + "";
  if (pu(e))
    return Nn ? Nn.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var yu = Va, gu = yu;
function bu(e) {
  return e == null ? "" : gu(e);
}
var Du = bu, wu = Ye, $u = nn, _u = du, Mu = Du;
function ku(e, t) {
  return wu(e) ? e : $u(e, t) ? [e] : _u(Mu(e));
}
var Ka = ku, Yu = Ie, Pu = Pe, Tu = "[object Arguments]";
function Cu(e) {
  return Pu(e) && Yu(e) == Tu;
}
var Ou = Cu, Ln = Ou, Su = Pe, Ga = Object.prototype, Iu = Ga.hasOwnProperty, Au = Ga.propertyIsEnumerable, Eu = Ln(/* @__PURE__ */ function() {
  return arguments;
}()) ? Ln : function(e) {
  return Su(e) && Iu.call(e, "callee") && !Au.call(e, "callee");
}, ln = Eu, Nu = 9007199254740991, Lu = /^(?:0|[1-9]\d*)$/;
function xu(e, t) {
  var r = typeof e;
  return t = t ?? Nu, !!t && (r == "number" || r != "symbol" && Lu.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var un = xu, Fu = 9007199254740991;
function Ru(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Fu;
}
var cn = Ru, Hu = rn;
function Wu(e) {
  if (typeof e == "string" || Hu(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var Mr = Wu, ju = Ka, Bu = ln, zu = Ye, Uu = un, Vu = cn, Ku = Mr;
function Gu(e, t, r) {
  t = ju(t, e);
  for (var n = -1, a = t.length, s = !1; ++n < a; ) {
    var o = Ku(t[n]);
    if (!(s = e != null && r(e, o)))
      break;
    e = e[o];
  }
  return s || ++n != a ? s : (a = e == null ? 0 : e.length, !!a && Vu(a) && Uu(o, a) && (zu(e) || Bu(e)));
}
var Za = Gu, Zu = bo, qu = Za;
function Xu(e, t) {
  return e != null && qu(e, t, Zu);
}
var qa = Xu, Ju = Ie, Qu = Pe, ec = "[object Date]";
function tc(e) {
  return Qu(e) && Ju(e) == ec;
}
var rc = tc;
function nc(e) {
  return function(t) {
    return e(t);
  };
}
var Xa = nc, Ft = {}, ac = {
  get exports() {
    return Ft;
  },
  set exports(e) {
    Ft = e;
  }
};
(function(e, t) {
  var r = ja, n = t && !t.nodeType && t, a = n && !0 && e && !e.nodeType && e, s = a && a.exports === n, o = s && r.process, i = function() {
    try {
      var u = a && a.require && a.require("util").types;
      return u || o && o.binding && o.binding("util");
    } catch {
    }
  }();
  e.exports = i;
})(ac, Ft);
var sc = rc, oc = Xa, xn = Ft, Fn = xn && xn.isDate, ic = Fn ? oc(Fn) : sc, lc = ic, uc = Ie, cc = Ye, dc = Pe, fc = "[object String]";
function vc(e) {
  return typeof e == "string" || !cc(e) && dc(e) && uc(e) == fc;
}
var Ce = vc;
function hc(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
var Ja = hc, mc = $r;
function pc() {
  this.__data__ = new mc(), this.size = 0;
}
var yc = pc;
function gc(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
var bc = gc;
function Dc(e) {
  return this.__data__.get(e);
}
var wc = Dc;
function $c(e) {
  return this.__data__.has(e);
}
var _c = $c, Mc = $r, kc = an, Yc = sn, Pc = 200;
function Tc(e, t) {
  var r = this.__data__;
  if (r instanceof Mc) {
    var n = r.__data__;
    if (!kc || n.length < Pc - 1)
      return n.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new Yc(n);
  }
  return r.set(e, t), this.size = r.size, this;
}
var Cc = Tc, Oc = $r, Sc = yc, Ic = bc, Ac = wc, Ec = _c, Nc = Cc;
function pt(e) {
  var t = this.__data__ = new Oc(e);
  this.size = t.size;
}
pt.prototype.clear = Sc;
pt.prototype.delete = Ic;
pt.prototype.get = Ac;
pt.prototype.has = Ec;
pt.prototype.set = Nc;
var dn = pt, Lc = "__lodash_hash_undefined__";
function xc(e) {
  return this.__data__.set(e, Lc), this;
}
var Fc = xc;
function Rc(e) {
  return this.__data__.has(e);
}
var Hc = Rc, Wc = sn, jc = Fc, Bc = Hc;
function lr(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new Wc(); ++t < r; )
    this.add(e[t]);
}
lr.prototype.add = lr.prototype.push = jc;
lr.prototype.has = Bc;
var zc = lr;
function Uc(e, t) {
  return e.has(t);
}
var Vc = Uc, Kc = zc, Gc = Ja, Zc = Vc, qc = 1, Xc = 2;
function Jc(e, t, r, n, a, s) {
  var o = r & qc, i = e.length, u = t.length;
  if (i != u && !(o && u > i))
    return !1;
  var c = s.get(e), d = s.get(t);
  if (c && d)
    return c == t && d == e;
  var f = -1, v = !0, h = r & Xc ? new Kc() : void 0;
  for (s.set(e, t), s.set(t, e); ++f < i; ) {
    var b = e[f], Y = t[f];
    if (n)
      var M = o ? n(Y, b, f, t, e, s) : n(b, Y, f, e, t, s);
    if (M !== void 0) {
      if (M)
        continue;
      v = !1;
      break;
    }
    if (h) {
      if (!Gc(t, function(D, N) {
        if (!Zc(h, N) && (b === D || a(b, D, r, n, s)))
          return h.push(N);
      })) {
        v = !1;
        break;
      }
    } else if (!(b === Y || a(b, Y, r, n, s))) {
      v = !1;
      break;
    }
  }
  return s.delete(e), s.delete(t), v;
}
var Qa = Jc, Qc = Se, ed = Qc.Uint8Array, es = ed;
function td(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n, a) {
    r[++t] = [a, n];
  }), r;
}
var rd = td;
function nd(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n) {
    r[++t] = n;
  }), r;
}
var ad = nd, Rn = br, Hn = es, sd = vt, od = Qa, id = rd, ld = ad, ud = 1, cd = 2, dd = "[object Boolean]", fd = "[object Date]", vd = "[object Error]", hd = "[object Map]", md = "[object Number]", pd = "[object RegExp]", yd = "[object Set]", gd = "[object String]", bd = "[object Symbol]", Dd = "[object ArrayBuffer]", wd = "[object DataView]", Wn = Rn ? Rn.prototype : void 0, Nr = Wn ? Wn.valueOf : void 0;
function $d(e, t, r, n, a, s, o) {
  switch (r) {
    case wd:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case Dd:
      return !(e.byteLength != t.byteLength || !s(new Hn(e), new Hn(t)));
    case dd:
    case fd:
    case md:
      return sd(+e, +t);
    case vd:
      return e.name == t.name && e.message == t.message;
    case pd:
    case gd:
      return e == t + "";
    case hd:
      var i = id;
    case yd:
      var u = n & ud;
      if (i || (i = ld), e.size != t.size && !u)
        return !1;
      var c = o.get(e);
      if (c)
        return c == t;
      n |= cd, o.set(e, t);
      var d = od(i(e), i(t), n, a, s, o);
      return o.delete(e), d;
    case bd:
      if (Nr)
        return Nr.call(e) == Nr.call(t);
  }
  return !1;
}
var _d = $d;
function Md(e, t) {
  for (var r = -1, n = t.length, a = e.length; ++r < n; )
    e[a + r] = t[r];
  return e;
}
var kd = Md, Yd = kd, Pd = Ye;
function Td(e, t, r) {
  var n = t(e);
  return Pd(e) ? n : Yd(n, r(e));
}
var Cd = Td;
function Od(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, a = 0, s = []; ++r < n; ) {
    var o = e[r];
    t(o, r, e) && (s[a++] = o);
  }
  return s;
}
var Sd = Od;
function Id() {
  return [];
}
var Ad = Id, Ed = Sd, Nd = Ad, Ld = Object.prototype, xd = Ld.propertyIsEnumerable, jn = Object.getOwnPropertySymbols, Fd = jn ? function(e) {
  return e == null ? [] : (e = Object(e), Ed(jn(e), function(t) {
    return xd.call(e, t);
  }));
} : Nd, Rd = Fd;
function Hd(e, t) {
  for (var r = -1, n = Array(e); ++r < e; )
    n[r] = t(r);
  return n;
}
var Wd = Hd, ut = {}, jd = {
  get exports() {
    return ut;
  },
  set exports(e) {
    ut = e;
  }
};
function Bd() {
  return !1;
}
var zd = Bd;
(function(e, t) {
  var r = Se, n = zd, a = t && !t.nodeType && t, s = a && !0 && e && !e.nodeType && e, o = s && s.exports === a, i = o ? r.Buffer : void 0, u = i ? i.isBuffer : void 0, c = u || n;
  e.exports = c;
})(jd, ut);
var Ud = Ie, Vd = cn, Kd = Pe, Gd = "[object Arguments]", Zd = "[object Array]", qd = "[object Boolean]", Xd = "[object Date]", Jd = "[object Error]", Qd = "[object Function]", ef = "[object Map]", tf = "[object Number]", rf = "[object Object]", nf = "[object RegExp]", af = "[object Set]", sf = "[object String]", of = "[object WeakMap]", lf = "[object ArrayBuffer]", uf = "[object DataView]", cf = "[object Float32Array]", df = "[object Float64Array]", ff = "[object Int8Array]", vf = "[object Int16Array]", hf = "[object Int32Array]", mf = "[object Uint8Array]", pf = "[object Uint8ClampedArray]", yf = "[object Uint16Array]", gf = "[object Uint32Array]", z = {};
z[cf] = z[df] = z[ff] = z[vf] = z[hf] = z[mf] = z[pf] = z[yf] = z[gf] = !0;
z[Gd] = z[Zd] = z[lf] = z[qd] = z[uf] = z[Xd] = z[Jd] = z[Qd] = z[ef] = z[tf] = z[rf] = z[nf] = z[af] = z[sf] = z[of] = !1;
function bf(e) {
  return Kd(e) && Vd(e.length) && !!z[Ud(e)];
}
var Df = bf, wf = Df, $f = Xa, Bn = Ft, zn = Bn && Bn.isTypedArray, _f = zn ? $f(zn) : wf, fn = _f, Mf = Wd, kf = ln, Yf = Ye, Pf = ut, Tf = un, Cf = fn, Of = Object.prototype, Sf = Of.hasOwnProperty;
function If(e, t) {
  var r = Yf(e), n = !r && kf(e), a = !r && !n && Pf(e), s = !r && !n && !a && Cf(e), o = r || n || a || s, i = o ? Mf(e.length, String) : [], u = i.length;
  for (var c in e)
    (t || Sf.call(e, c)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    s && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    Tf(c, u))) && i.push(c);
  return i;
}
var ts = If, Af = Object.prototype;
function Ef(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || Af;
  return e === r;
}
var vn = Ef;
function Nf(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var rs = Nf, Lf = rs, xf = Lf(Object.keys, Object), Ff = xf, Rf = vn, Hf = Ff, Wf = Object.prototype, jf = Wf.hasOwnProperty;
function Bf(e) {
  if (!Rf(e))
    return Hf(e);
  var t = [];
  for (var r in Object(e))
    jf.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
var zf = Bf, Uf = Qe, Vf = cn;
function Kf(e) {
  return e != null && Vf(e.length) && !Uf(e);
}
var zt = Kf, Gf = ts, Zf = zf, qf = zt;
function Xf(e) {
  return qf(e) ? Gf(e) : Zf(e);
}
var hn = Xf, Jf = Cd, Qf = Rd, ev = hn;
function tv(e) {
  return Jf(e, ev, Qf);
}
var rv = tv, Un = rv, nv = 1, av = Object.prototype, sv = av.hasOwnProperty;
function ov(e, t, r, n, a, s) {
  var o = r & nv, i = Un(e), u = i.length, c = Un(t), d = c.length;
  if (u != d && !o)
    return !1;
  for (var f = u; f--; ) {
    var v = i[f];
    if (!(o ? v in t : sv.call(t, v)))
      return !1;
  }
  var h = s.get(e), b = s.get(t);
  if (h && b)
    return h == t && b == e;
  var Y = !0;
  s.set(e, t), s.set(t, e);
  for (var M = o; ++f < u; ) {
    v = i[f];
    var D = e[v], N = t[v];
    if (n)
      var B = o ? n(N, D, v, t, e, s) : n(D, N, v, e, t, s);
    if (!(B === void 0 ? D === N || a(D, N, r, n, s) : B)) {
      Y = !1;
      break;
    }
    M || (M = v == "constructor");
  }
  if (Y && !M) {
    var A = e.constructor, I = t.constructor;
    A != I && "constructor" in e && "constructor" in t && !(typeof A == "function" && A instanceof A && typeof I == "function" && I instanceof I) && (Y = !1);
  }
  return s.delete(e), s.delete(t), Y;
}
var iv = ov, lv = et, uv = Se, cv = lv(uv, "DataView"), dv = cv, fv = et, vv = Se, hv = fv(vv, "Promise"), mv = hv, pv = et, yv = Se, gv = pv(yv, "Set"), bv = gv, Dv = et, wv = Se, $v = Dv(wv, "WeakMap"), _v = $v, Br = dv, zr = an, Ur = mv, Vr = bv, Kr = _v, ns = Ie, yt = za, Vn = "[object Map]", Mv = "[object Object]", Kn = "[object Promise]", Gn = "[object Set]", Zn = "[object WeakMap]", qn = "[object DataView]", kv = yt(Br), Yv = yt(zr), Pv = yt(Ur), Tv = yt(Vr), Cv = yt(Kr), qe = ns;
(Br && qe(new Br(new ArrayBuffer(1))) != qn || zr && qe(new zr()) != Vn || Ur && qe(Ur.resolve()) != Kn || Vr && qe(new Vr()) != Gn || Kr && qe(new Kr()) != Zn) && (qe = function(e) {
  var t = ns(e), r = t == Mv ? e.constructor : void 0, n = r ? yt(r) : "";
  if (n)
    switch (n) {
      case kv:
        return qn;
      case Yv:
        return Vn;
      case Pv:
        return Kn;
      case Tv:
        return Gn;
      case Cv:
        return Zn;
    }
  return t;
});
var Ov = qe, Lr = dn, Sv = Qa, Iv = _d, Av = iv, Xn = Ov, Jn = Ye, Qn = ut, Ev = fn, Nv = 1, ea = "[object Arguments]", ta = "[object Array]", tr = "[object Object]", Lv = Object.prototype, ra = Lv.hasOwnProperty;
function xv(e, t, r, n, a, s) {
  var o = Jn(e), i = Jn(t), u = o ? ta : Xn(e), c = i ? ta : Xn(t);
  u = u == ea ? tr : u, c = c == ea ? tr : c;
  var d = u == tr, f = c == tr, v = u == c;
  if (v && Qn(e)) {
    if (!Qn(t))
      return !1;
    o = !0, d = !1;
  }
  if (v && !d)
    return s || (s = new Lr()), o || Ev(e) ? Sv(e, t, r, n, a, s) : Iv(e, t, u, r, n, a, s);
  if (!(r & Nv)) {
    var h = d && ra.call(e, "__wrapped__"), b = f && ra.call(t, "__wrapped__");
    if (h || b) {
      var Y = h ? e.value() : e, M = b ? t.value() : t;
      return s || (s = new Lr()), a(Y, M, r, n, s);
    }
  }
  return v ? (s || (s = new Lr()), Av(e, t, r, n, a, s)) : !1;
}
var Fv = xv, Rv = Fv, na = Pe;
function as(e, t, r, n, a) {
  return e === t ? !0 : e == null || t == null || !na(e) && !na(t) ? e !== e && t !== t : Rv(e, t, r, n, as, a);
}
var ss = as, Hv = dn, Wv = ss, jv = 1, Bv = 2;
function zv(e, t, r, n) {
  var a = r.length, s = a, o = !n;
  if (e == null)
    return !s;
  for (e = Object(e); a--; ) {
    var i = r[a];
    if (o && i[2] ? i[1] !== e[i[0]] : !(i[0] in e))
      return !1;
  }
  for (; ++a < s; ) {
    i = r[a];
    var u = i[0], c = e[u], d = i[1];
    if (o && i[2]) {
      if (c === void 0 && !(u in e))
        return !1;
    } else {
      var f = new Hv();
      if (n)
        var v = n(c, d, u, e, t, f);
      if (!(v === void 0 ? Wv(d, c, jv | Bv, n, f) : v))
        return !1;
    }
  }
  return !0;
}
var Uv = zv, Vv = He;
function Kv(e) {
  return e === e && !Vv(e);
}
var os = Kv, Gv = os, Zv = hn;
function qv(e) {
  for (var t = Zv(e), r = t.length; r--; ) {
    var n = t[r], a = e[n];
    t[r] = [n, a, Gv(a)];
  }
  return t;
}
var Xv = qv;
function Jv(e, t) {
  return function(r) {
    return r == null ? !1 : r[e] === t && (t !== void 0 || e in Object(r));
  };
}
var is = Jv, Qv = Uv, eh = Xv, th = is;
function rh(e) {
  var t = eh(e);
  return t.length == 1 && t[0][2] ? th(t[0][0], t[0][1]) : function(r) {
    return r === e || Qv(r, e, t);
  };
}
var nh = rh, ah = Ka, sh = Mr;
function oh(e, t) {
  t = ah(t, e);
  for (var r = 0, n = t.length; e != null && r < n; )
    e = e[sh(t[r++])];
  return r && r == n ? e : void 0;
}
var ls = oh, ih = ls;
function lh(e, t, r) {
  var n = e == null ? void 0 : ih(e, t);
  return n === void 0 ? r : n;
}
var Xe = lh;
function uh(e, t) {
  return e != null && t in Object(e);
}
var ch = uh, dh = ch, fh = Za;
function vh(e, t) {
  return e != null && fh(e, t, dh);
}
var hh = vh, mh = ss, ph = Xe, yh = hh, gh = nn, bh = os, Dh = is, wh = Mr, $h = 1, _h = 2;
function Mh(e, t) {
  return gh(e) && bh(t) ? Dh(wh(e), t) : function(r) {
    var n = ph(r, e);
    return n === void 0 && n === t ? yh(r, e) : mh(t, n, $h | _h);
  };
}
var kh = Mh;
function Yh(e) {
  return e;
}
var mn = Yh;
function Ph(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var Th = Ph, Ch = ls;
function Oh(e) {
  return function(t) {
    return Ch(t, e);
  };
}
var Sh = Oh, Ih = Th, Ah = Sh, Eh = nn, Nh = Mr;
function Lh(e) {
  return Eh(e) ? Ih(Nh(e)) : Ah(e);
}
var xh = Lh, Fh = nh, Rh = kh, Hh = mn, Wh = Ye, jh = xh;
function Bh(e) {
  return typeof e == "function" ? e : e == null ? Hh : typeof e == "object" ? Wh(e) ? Rh(e[0], e[1]) : Fh(e) : jh(e);
}
var us = Bh;
function zh(e) {
  return function(t, r, n) {
    for (var a = -1, s = Object(t), o = n(t), i = o.length; i--; ) {
      var u = o[e ? i : ++a];
      if (r(s[u], u, s) === !1)
        break;
    }
    return t;
  };
}
var Uh = zh, Vh = Uh, Kh = Vh(), cs = Kh, Gh = cs, Zh = hn;
function qh(e, t) {
  return e && Gh(e, t, Zh);
}
var ds = qh, Xh = zt;
function Jh(e, t) {
  return function(r, n) {
    if (r == null)
      return r;
    if (!Xh(r))
      return e(r, n);
    for (var a = r.length, s = t ? a : -1, o = Object(r); (t ? s-- : ++s < a) && n(o[s], s, o) !== !1; )
      ;
    return r;
  };
}
var Qh = Jh, em = ds, tm = Qh, rm = tm(em), nm = rm, am = nm;
function sm(e, t) {
  var r;
  return am(e, function(n, a, s) {
    return r = t(n, a, s), !r;
  }), !!r;
}
var om = sm, im = vt, lm = zt, um = un, cm = He;
function dm(e, t, r) {
  if (!cm(r))
    return !1;
  var n = typeof t;
  return (n == "number" ? lm(r) && um(t, r.length) : n == "string" && t in r) ? im(r[t], e) : !1;
}
var pn = dm, fm = Ja, vm = us, hm = om, mm = Ye, pm = pn;
function ym(e, t, r) {
  var n = mm(e) ? fm : hm;
  return r && pm(e, t, r) && (t = void 0), n(e, vm(t));
}
var gm = ym, bm = Ie, Dm = Pe, wm = "[object Boolean]";
function $m(e) {
  return e === !0 || e === !1 || Dm(e) && bm(e) == wm;
}
var _m = $m, Mm = Ie, km = Pe, Ym = "[object Number]";
function Pm(e) {
  return typeof e == "number" || km(e) && Mm(e) == Ym;
}
var ke = Pm, Tm = et, Cm = function() {
  try {
    var e = Tm(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), fs = Cm, aa = fs;
function Om(e, t, r) {
  t == "__proto__" && aa ? aa(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
var kr = Om, Sm = kr, Im = vt, Am = Object.prototype, Em = Am.hasOwnProperty;
function Nm(e, t, r) {
  var n = e[t];
  (!(Em.call(e, t) && Im(n, r)) || r === void 0 && !(t in e)) && Sm(e, t, r);
}
var Lm = Nm, xm = kr, Fm = ds, Rm = us;
function Hm(e, t) {
  var r = {};
  return t = Rm(t), Fm(e, function(n, a, s) {
    xm(r, a, t(n, a, s));
  }), r;
}
var Wm = Hm;
function jm(e, t, r) {
  switch (r.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, r[0]);
    case 2:
      return e.call(t, r[0], r[1]);
    case 3:
      return e.call(t, r[0], r[1], r[2]);
  }
  return e.apply(t, r);
}
var vs = jm, Bm = vs, sa = Math.max;
function zm(e, t, r) {
  return t = sa(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var n = arguments, a = -1, s = sa(n.length - t, 0), o = Array(s); ++a < s; )
      o[a] = n[t + a];
    a = -1;
    for (var i = Array(t + 1); ++a < t; )
      i[a] = n[a];
    return i[t] = r(o), Bm(e, this, i);
  };
}
var Um = zm;
function Vm(e) {
  return function() {
    return e;
  };
}
var Km = Vm, Gm = Km, oa = fs, Zm = mn, qm = oa ? function(e, t) {
  return oa(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: Gm(t),
    writable: !0
  });
} : Zm, Xm = qm, Jm = 800, Qm = 16, ep = Date.now;
function tp(e) {
  var t = 0, r = 0;
  return function() {
    var n = ep(), a = Qm - (n - r);
    if (r = n, a > 0) {
      if (++t >= Jm)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
var rp = tp, np = Xm, ap = rp, sp = ap(np), op = sp, ip = mn, lp = Um, up = op;
function cp(e, t) {
  return up(lp(e, t, ip), e + "");
}
var yn = cp;
function dp(e) {
  var t = [];
  if (e != null)
    for (var r in Object(e))
      t.push(r);
  return t;
}
var fp = dp, vp = He, hp = vn, mp = fp, pp = Object.prototype, yp = pp.hasOwnProperty;
function gp(e) {
  if (!vp(e))
    return mp(e);
  var t = hp(e), r = [];
  for (var n in e)
    n == "constructor" && (t || !yp.call(e, n)) || r.push(n);
  return r;
}
var bp = gp, Dp = ts, wp = bp, $p = zt;
function _p(e) {
  return $p(e) ? Dp(e, !0) : wp(e);
}
var gn = _p, Mp = yn, kp = vt, Yp = pn, Pp = gn, hs = Object.prototype, Tp = hs.hasOwnProperty, Cp = Mp(function(e, t) {
  e = Object(e);
  var r = -1, n = t.length, a = n > 2 ? t[2] : void 0;
  for (a && Yp(t[0], t[1], a) && (n = 1); ++r < n; )
    for (var s = t[r], o = Pp(s), i = -1, u = o.length; ++i < u; ) {
      var c = o[i], d = e[c];
      (d === void 0 || kp(d, hs[c]) && !Tp.call(e, c)) && (e[c] = s[c]);
    }
  return e;
}), ia = Cp, Op = kr, Sp = vt;
function Ip(e, t, r) {
  (r !== void 0 && !Sp(e[t], r) || r === void 0 && !(t in e)) && Op(e, t, r);
}
var ms = Ip, ur = {}, Ap = {
  get exports() {
    return ur;
  },
  set exports(e) {
    ur = e;
  }
};
(function(e, t) {
  var r = Se, n = t && !t.nodeType && t, a = n && !0 && e && !e.nodeType && e, s = a && a.exports === n, o = s ? r.Buffer : void 0, i = o ? o.allocUnsafe : void 0;
  function u(c, d) {
    if (d)
      return c.slice();
    var f = c.length, v = i ? i(f) : new c.constructor(f);
    return c.copy(v), v;
  }
  e.exports = u;
})(Ap, ur);
var la = es;
function Ep(e) {
  var t = new e.constructor(e.byteLength);
  return new la(t).set(new la(e)), t;
}
var Np = Ep, Lp = Np;
function xp(e, t) {
  var r = t ? Lp(e.buffer) : e.buffer;
  return new e.constructor(r, e.byteOffset, e.length);
}
var Fp = xp;
function Rp(e, t) {
  var r = -1, n = e.length;
  for (t || (t = Array(n)); ++r < n; )
    t[r] = e[r];
  return t;
}
var Hp = Rp, Wp = He, ua = Object.create, jp = /* @__PURE__ */ function() {
  function e() {
  }
  return function(t) {
    if (!Wp(t))
      return {};
    if (ua)
      return ua(t);
    e.prototype = t;
    var r = new e();
    return e.prototype = void 0, r;
  };
}(), Bp = jp, zp = rs, Up = zp(Object.getPrototypeOf, Object), ps = Up, Vp = Bp, Kp = ps, Gp = vn;
function Zp(e) {
  return typeof e.constructor == "function" && !Gp(e) ? Vp(Kp(e)) : {};
}
var qp = Zp, Xp = zt, Jp = Pe;
function Qp(e) {
  return Jp(e) && Xp(e);
}
var ey = Qp, ty = Ie, ry = ps, ny = Pe, ay = "[object Object]", sy = Function.prototype, oy = Object.prototype, ys = sy.toString, iy = oy.hasOwnProperty, ly = ys.call(Object);
function uy(e) {
  if (!ny(e) || ty(e) != ay)
    return !1;
  var t = ry(e);
  if (t === null)
    return !0;
  var r = iy.call(t, "constructor") && t.constructor;
  return typeof r == "function" && r instanceof r && ys.call(r) == ly;
}
var cy = uy;
function dy(e, t) {
  if (!(t === "constructor" && typeof e[t] == "function") && t != "__proto__")
    return e[t];
}
var gs = dy, fy = Lm, vy = kr;
function hy(e, t, r, n) {
  var a = !r;
  r || (r = {});
  for (var s = -1, o = t.length; ++s < o; ) {
    var i = t[s], u = n ? n(r[i], e[i], i, r, e) : void 0;
    u === void 0 && (u = e[i]), a ? vy(r, i, u) : fy(r, i, u);
  }
  return r;
}
var my = hy, py = my, yy = gn;
function gy(e) {
  return py(e, yy(e));
}
var by = gy, ca = ms, Dy = ur, wy = Fp, $y = Hp, _y = qp, da = ln, fa = Ye, My = ey, ky = ut, Yy = Qe, Py = He, Ty = cy, Cy = fn, va = gs, Oy = by;
function Sy(e, t, r, n, a, s, o) {
  var i = va(e, r), u = va(t, r), c = o.get(u);
  if (c) {
    ca(e, r, c);
    return;
  }
  var d = s ? s(i, u, r + "", e, t, o) : void 0, f = d === void 0;
  if (f) {
    var v = fa(u), h = !v && ky(u), b = !v && !h && Cy(u);
    d = u, v || h || b ? fa(i) ? d = i : My(i) ? d = $y(i) : h ? (f = !1, d = Dy(u, !0)) : b ? (f = !1, d = wy(u, !0)) : d = [] : Ty(u) || da(u) ? (d = i, da(i) ? d = Oy(i) : (!Py(i) || Yy(i)) && (d = _y(u))) : f = !1;
  }
  f && (o.set(u, d), a(d, u, n, s, o), o.delete(u)), ca(e, r, d);
}
var Iy = Sy, Ay = dn, Ey = ms, Ny = cs, Ly = Iy, xy = He, Fy = gn, Ry = gs;
function bs(e, t, r, n, a) {
  e !== t && Ny(t, function(s, o) {
    if (a || (a = new Ay()), xy(s))
      Ly(e, t, o, r, bs, n, a);
    else {
      var i = n ? n(Ry(e, o), s, o + "", e, t, a) : void 0;
      i === void 0 && (i = s), Ey(e, o, i);
    }
  }, Fy);
}
var Ds = bs, Hy = Ds, ha = He;
function ws(e, t, r, n, a, s) {
  return ha(e) && ha(t) && (s.set(t, e), Hy(e, t, void 0, ws, s), s.delete(t)), e;
}
var Wy = ws, jy = yn, By = pn;
function zy(e) {
  return jy(function(t, r) {
    var n = -1, a = r.length, s = a > 1 ? r[a - 1] : void 0, o = a > 2 ? r[2] : void 0;
    for (s = e.length > 3 && typeof s == "function" ? (a--, s) : void 0, o && By(r[0], r[1], o) && (s = a < 3 ? void 0 : s, a = 1), t = Object(t); ++n < a; ) {
      var i = r[n];
      i && e(t, i, n, s);
    }
    return t;
  });
}
var Uy = zy, Vy = Ds, Ky = Uy, Gy = Ky(function(e, t, r, n) {
  Vy(e, t, r, n);
}), Zy = Gy, qy = vs, Xy = yn, Jy = Wy, Qy = Zy, eg = Xy(function(e) {
  return e.push(void 0, Jy), qy(Qy, void 0, e);
}), Rt = eg;
function tg(e) {
  return e && e.length ? e[0] : void 0;
}
var $s = tg;
function rg(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
var ot = rg;
const ng = (e) => Object.prototype.toString.call(e).slice(8, -1), it = (e) => lc(e) && !isNaN(e.getTime()), Fe = (e) => ng(e) === "Object", _s = qa, ma = (e, t) => gm(t, (r) => qa(e, r)), W = (e, t, r = "0") => {
  for (e = e != null ? String(e) : "", t = t || 2; e.length < t; )
    e = `${r}${e}`;
  return e;
}, $e = (e) => Array.isArray(e), xe = (e) => $e(e) && e.length > 0, cr = (e) => e == null ? null : document && Ce(e) ? document.querySelector(e) : e.$el ?? e, Be = (e, t, r, n = void 0) => {
  e.removeEventListener(t, r, n);
}, ze = (e, t, r, n = void 0) => (e.addEventListener(t, r, n), () => Be(e, t, r, n)), ar = (e, t) => !!e && !!t && (e === t || e.contains(t)), rr = (e, t) => {
  (e.key === " " || e.key === "Enter") && (t(e), e.preventDefault());
}, Ms = (e, ...t) => {
  const r = {};
  let n;
  for (n in e)
    t.includes(n) || (r[n] = e[n]);
  return r;
}, ks = (e, t) => {
  const r = {};
  return t.forEach((n) => {
    n in e && (r[n] = e[n]);
  }), r;
};
function ag(e, t, r) {
  return Math.min(Math.max(e, t), r);
}
var dr = {}, sg = {
  get exports() {
    return dr;
  },
  set exports(e) {
    dr = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r(n) {
    if (n === null || n === !0 || n === !1)
      return NaN;
    var a = Number(n);
    return isNaN(a) ? a : a < 0 ? Math.ceil(a) : Math.floor(a);
  }
  e.exports = t.default;
})(sg, dr);
const og = /* @__PURE__ */ Wa(dr);
var fr = {}, ig = {
  get exports() {
    return fr;
  },
  set exports(e) {
    fr = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r(n) {
    var a = new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate(), n.getHours(), n.getMinutes(), n.getSeconds(), n.getMilliseconds()));
    return a.setUTCFullYear(n.getFullYear()), n.getTime() - a.getTime();
  }
  e.exports = t.default;
})(ig, fr);
const pa = /* @__PURE__ */ Wa(fr);
function lg(e, t) {
  var r = fg(t);
  return r.formatToParts ? cg(r, e) : dg(r, e);
}
var ug = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function cg(e, t) {
  try {
    for (var r = e.formatToParts(t), n = [], a = 0; a < r.length; a++) {
      var s = ug[r[a].type];
      s >= 0 && (n[s] = parseInt(r[a].value, 10));
    }
    return n;
  } catch (o) {
    if (o instanceof RangeError)
      return [NaN];
    throw o;
  }
}
function dg(e, t) {
  var r = e.format(t).replace(/\u200E/g, ""), n = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(r);
  return [n[3], n[1], n[2], n[4], n[5], n[6]];
}
var xr = {};
function fg(e) {
  if (!xr[e]) {
    var t = new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: "America/New_York",
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), r = t === "06/25/2014, 00:00:00" || t === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
    xr[e] = r ? new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
  return xr[e];
}
function Ys(e, t, r, n, a, s, o) {
  var i = /* @__PURE__ */ new Date(0);
  return i.setUTCFullYear(e, t, r), i.setUTCHours(n, a, s, o), i;
}
var ya = 36e5, vg = 6e4, Fr = {
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-]\d{2}):?(\d{2})$/
};
function hg(e, t, r) {
  var n, a;
  if (!e || (n = Fr.timezoneZ.exec(e), n))
    return 0;
  var s;
  if (n = Fr.timezoneHH.exec(e), n)
    return s = parseInt(n[1], 10), ga(s) ? -(s * ya) : NaN;
  if (n = Fr.timezoneHHMM.exec(e), n) {
    s = parseInt(n[1], 10);
    var o = parseInt(n[2], 10);
    return ga(s, o) ? (a = Math.abs(s) * ya + o * vg, s > 0 ? -a : a) : NaN;
  }
  if (yg(e)) {
    t = new Date(t || Date.now());
    var i = mg(t), u = Gr(i, e), c = pg(t, u, e);
    return -c;
  }
  return NaN;
}
function mg(e) {
  return Ys(
    e.getFullYear(),
    e.getMonth(),
    e.getDate(),
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  );
}
function Gr(e, t) {
  var r = lg(e, t), n = Ys(
    r[0],
    r[1] - 1,
    r[2],
    r[3] % 24,
    r[4],
    r[5],
    0
  ).getTime(), a = e.getTime(), s = a % 1e3;
  return a -= s >= 0 ? s : 1e3 + s, n - a;
}
function pg(e, t, r) {
  var n = e.getTime(), a = n - t, s = Gr(new Date(a), r);
  if (t === s)
    return t;
  a -= s - t;
  var o = Gr(new Date(a), r);
  return s === o ? s : Math.max(s, o);
}
function ga(e, t) {
  return -23 <= e && e <= 23 && (t == null || 0 <= t && t <= 59);
}
var ba = {};
function yg(e) {
  if (ba[e])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: e }), ba[e] = !0, !0;
  } catch {
    return !1;
  }
}
var gg = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
const bg = gg;
var Rr = 36e5, Da = 6e4, Dg = 2, he = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: bg
};
function wg(e, t) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (e === null)
    return /* @__PURE__ */ new Date(NaN);
  var r = t || {}, n = r.additionalDigits == null ? Dg : og(r.additionalDigits);
  if (n !== 2 && n !== 1 && n !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]")
    return new Date(e.getTime());
  if (typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]")
    return new Date(e);
  if (!(typeof e == "string" || Object.prototype.toString.call(e) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var a = $g(e), s = _g(a.date, n), o = s.year, i = s.restDateString, u = Mg(i, o);
  if (isNaN(u))
    return /* @__PURE__ */ new Date(NaN);
  if (u) {
    var c = u.getTime(), d = 0, f;
    if (a.time && (d = kg(a.time), isNaN(d)))
      return /* @__PURE__ */ new Date(NaN);
    if (a.timeZone || r.timeZone) {
      if (f = hg(a.timeZone || r.timeZone, new Date(c + d)), isNaN(f))
        return /* @__PURE__ */ new Date(NaN);
    } else
      f = pa(new Date(c + d)), f = pa(new Date(c + d + f));
    return new Date(c + d + f);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function $g(e) {
  var t = {}, r = he.dateTimePattern.exec(e), n;
  if (r ? (t.date = r[1], n = r[3]) : (r = he.datePattern.exec(e), r ? (t.date = r[1], n = r[2]) : (t.date = null, n = e)), n) {
    var a = he.timeZone.exec(n);
    a ? (t.time = n.replace(a[1], ""), t.timeZone = a[1].trim()) : t.time = n;
  }
  return t;
}
function _g(e, t) {
  var r = he.YYY[t], n = he.YYYYY[t], a;
  if (a = he.YYYY.exec(e) || n.exec(e), a) {
    var s = a[1];
    return {
      year: parseInt(s, 10),
      restDateString: e.slice(s.length)
    };
  }
  if (a = he.YY.exec(e) || r.exec(e), a) {
    var o = a[1];
    return {
      year: parseInt(o, 10) * 100,
      restDateString: e.slice(o.length)
    };
  }
  return {
    year: null
  };
}
function Mg(e, t) {
  if (t === null)
    return null;
  var r, n, a, s;
  if (e.length === 0)
    return n = /* @__PURE__ */ new Date(0), n.setUTCFullYear(t), n;
  if (r = he.MM.exec(e), r)
    return n = /* @__PURE__ */ new Date(0), a = parseInt(r[1], 10) - 1, $a(t, a) ? (n.setUTCFullYear(t, a), n) : /* @__PURE__ */ new Date(NaN);
  if (r = he.DDD.exec(e), r) {
    n = /* @__PURE__ */ new Date(0);
    var o = parseInt(r[1], 10);
    return Tg(t, o) ? (n.setUTCFullYear(t, 0, o), n) : /* @__PURE__ */ new Date(NaN);
  }
  if (r = he.MMDD.exec(e), r) {
    n = /* @__PURE__ */ new Date(0), a = parseInt(r[1], 10) - 1;
    var i = parseInt(r[2], 10);
    return $a(t, a, i) ? (n.setUTCFullYear(t, a, i), n) : /* @__PURE__ */ new Date(NaN);
  }
  if (r = he.Www.exec(e), r)
    return s = parseInt(r[1], 10) - 1, _a(t, s) ? wa(t, s) : /* @__PURE__ */ new Date(NaN);
  if (r = he.WwwD.exec(e), r) {
    s = parseInt(r[1], 10) - 1;
    var u = parseInt(r[2], 10) - 1;
    return _a(t, s, u) ? wa(t, s, u) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function kg(e) {
  var t, r, n;
  if (t = he.HH.exec(e), t)
    return r = parseFloat(t[1].replace(",", ".")), Hr(r) ? r % 24 * Rr : NaN;
  if (t = he.HHMM.exec(e), t)
    return r = parseInt(t[1], 10), n = parseFloat(t[2].replace(",", ".")), Hr(r, n) ? r % 24 * Rr + n * Da : NaN;
  if (t = he.HHMMSS.exec(e), t) {
    r = parseInt(t[1], 10), n = parseInt(t[2], 10);
    var a = parseFloat(t[3].replace(",", "."));
    return Hr(r, n, a) ? r % 24 * Rr + n * Da + a * 1e3 : NaN;
  }
  return null;
}
function wa(e, t, r) {
  t = t || 0, r = r || 0;
  var n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(e, 0, 4);
  var a = n.getUTCDay() || 7, s = t * 7 + r + 1 - a;
  return n.setUTCDate(n.getUTCDate() + s), n;
}
var Yg = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Pg = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function Ps(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function $a(e, t, r) {
  if (t < 0 || t > 11)
    return !1;
  if (r != null) {
    if (r < 1)
      return !1;
    var n = Ps(e);
    if (n && r > Pg[t] || !n && r > Yg[t])
      return !1;
  }
  return !0;
}
function Tg(e, t) {
  if (t < 1)
    return !1;
  var r = Ps(e);
  return !(r && t > 366 || !r && t > 365);
}
function _a(e, t, r) {
  return !(t < 0 || t > 52 || r != null && (r < 0 || r > 6));
}
function Hr(e, t, r) {
  return !(e != null && (e < 0 || e >= 25) || t != null && (t < 0 || t >= 60) || r != null && (r < 0 || r >= 60));
}
function ie(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function sr(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? sr = function(r) {
    return typeof r;
  } : sr = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, sr(e);
}
function We(e) {
  ie(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || sr(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function gt(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
var Cg = {};
function bn() {
  return Cg;
}
function Je(e, t) {
  var r, n, a, s, o, i, u, c;
  ie(1, arguments);
  var d = bn(), f = gt((r = (n = (a = (s = t == null ? void 0 : t.weekStartsOn) !== null && s !== void 0 ? s : t == null || (o = t.locale) === null || o === void 0 || (i = o.options) === null || i === void 0 ? void 0 : i.weekStartsOn) !== null && a !== void 0 ? a : d.weekStartsOn) !== null && n !== void 0 ? n : (u = d.locale) === null || u === void 0 || (c = u.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(f >= 0 && f <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var v = We(e), h = v.getDay(), b = (h < f ? 7 : 0) + h - f;
  return v.setDate(v.getDate() - b), v.setHours(0, 0, 0, 0), v;
}
function Ma(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
var Og = 6048e5;
function Sg(e, t, r) {
  ie(2, arguments);
  var n = Je(e, r), a = Je(t, r), s = n.getTime() - Ma(n), o = a.getTime() - Ma(a);
  return Math.round((s - o) / Og);
}
function Ig(e) {
  ie(1, arguments);
  var t = We(e), r = t.getMonth();
  return t.setFullYear(t.getFullYear(), r + 1, 0), t.setHours(0, 0, 0, 0), t;
}
function Ag(e) {
  ie(1, arguments);
  var t = We(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function Eg(e, t) {
  return ie(1, arguments), Sg(Ig(e), Ag(e), t) + 1;
}
function Ng(e, t) {
  var r, n, a, s, o, i, u, c;
  ie(1, arguments);
  var d = We(e), f = d.getFullYear(), v = bn(), h = gt((r = (n = (a = (s = t == null ? void 0 : t.firstWeekContainsDate) !== null && s !== void 0 ? s : t == null || (o = t.locale) === null || o === void 0 || (i = o.options) === null || i === void 0 ? void 0 : i.firstWeekContainsDate) !== null && a !== void 0 ? a : v.firstWeekContainsDate) !== null && n !== void 0 ? n : (u = v.locale) === null || u === void 0 || (c = u.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && r !== void 0 ? r : 1);
  if (!(h >= 1 && h <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var b = /* @__PURE__ */ new Date(0);
  b.setFullYear(f + 1, 0, h), b.setHours(0, 0, 0, 0);
  var Y = Je(b, t), M = /* @__PURE__ */ new Date(0);
  M.setFullYear(f, 0, h), M.setHours(0, 0, 0, 0);
  var D = Je(M, t);
  return d.getTime() >= Y.getTime() ? f + 1 : d.getTime() >= D.getTime() ? f : f - 1;
}
function Lg(e, t) {
  var r, n, a, s, o, i, u, c;
  ie(1, arguments);
  var d = bn(), f = gt((r = (n = (a = (s = t == null ? void 0 : t.firstWeekContainsDate) !== null && s !== void 0 ? s : t == null || (o = t.locale) === null || o === void 0 || (i = o.options) === null || i === void 0 ? void 0 : i.firstWeekContainsDate) !== null && a !== void 0 ? a : d.firstWeekContainsDate) !== null && n !== void 0 ? n : (u = d.locale) === null || u === void 0 || (c = u.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && r !== void 0 ? r : 1), v = Ng(e, t), h = /* @__PURE__ */ new Date(0);
  h.setFullYear(v, 0, f), h.setHours(0, 0, 0, 0);
  var b = Je(h, t);
  return b;
}
var xg = 6048e5;
function Fg(e, t) {
  ie(1, arguments);
  var r = We(e), n = Je(r, t).getTime() - Lg(r, t).getTime();
  return Math.round(n / xg) + 1;
}
function vr(e) {
  return ie(1, arguments), Je(e, {
    weekStartsOn: 1
  });
}
function Rg(e) {
  ie(1, arguments);
  var t = We(e), r = t.getFullYear(), n = /* @__PURE__ */ new Date(0);
  n.setFullYear(r + 1, 0, 4), n.setHours(0, 0, 0, 0);
  var a = vr(n), s = /* @__PURE__ */ new Date(0);
  s.setFullYear(r, 0, 4), s.setHours(0, 0, 0, 0);
  var o = vr(s);
  return t.getTime() >= a.getTime() ? r + 1 : t.getTime() >= o.getTime() ? r : r - 1;
}
function Hg(e) {
  ie(1, arguments);
  var t = Rg(e), r = /* @__PURE__ */ new Date(0);
  r.setFullYear(t, 0, 4), r.setHours(0, 0, 0, 0);
  var n = vr(r);
  return n;
}
var Wg = 6048e5;
function jg(e) {
  ie(1, arguments);
  var t = We(e), r = vr(t).getTime() - Hg(t).getTime();
  return Math.round(r / Wg) + 1;
}
function ve(e, t) {
  ie(2, arguments);
  var r = We(e), n = gt(t);
  return isNaN(n) ? /* @__PURE__ */ new Date(NaN) : (n && r.setDate(r.getDate() + n), r);
}
function hr(e, t) {
  ie(2, arguments);
  var r = We(e), n = gt(t);
  if (isNaN(n))
    return /* @__PURE__ */ new Date(NaN);
  if (!n)
    return r;
  var a = r.getDate(), s = new Date(r.getTime());
  s.setMonth(r.getMonth() + n + 1, 0);
  var o = s.getDate();
  return a >= o ? s : (r.setFullYear(s.getFullYear(), s.getMonth(), a), r);
}
function ka(e, t) {
  ie(2, arguments);
  var r = gt(t);
  return hr(e, r * 12);
}
const Bg = {
  daily: ["year", "month", "day"],
  weekly: ["year", "month", "week"],
  monthly: ["year", "month"]
};
function zg({
  monthComps: e,
  prevMonthComps: t,
  nextMonthComps: r
}, n) {
  const a = [], {
    firstDayOfWeek: s,
    firstWeekday: o,
    isoWeeknumbers: i,
    weeknumbers: u,
    numDays: c,
    numWeeks: d
  } = e, f = o + (o < s ? oe : 0) - s;
  let v = !0, h = !1, b = !1, Y = 0;
  const M = new Intl.DateTimeFormat(n.id, {
    weekday: "long",
    year: "numeric",
    month: "short",
    day: "numeric"
  });
  let D = t.numDays - f + 1, N = t.numDays - D + 1, B = Math.floor((D - 1) / oe + 1), A = 1, I = t.numWeeks, q = 1, E = t.month, L = t.year;
  const X = /* @__PURE__ */ new Date(), re = X.getDate(), J = X.getMonth() + 1, C = X.getFullYear();
  for (let R = 1; R <= L1; R++) {
    for (let K = 1, O = s; K <= oe; K++, O += O === oe ? 1 - oe : 1) {
      v && O === o && (D = 1, N = e.numDays, B = Math.floor((D - 1) / oe + 1), A = Math.floor((c - D) / oe + 1), I = 1, q = d, E = e.month, L = e.year, v = !1, h = !0);
      const te = n.getDateFromParams(L, E, D, 0, 0, 0, 0), le = n.getDateFromParams(L, E, D, 12, 0, 0, 0), ye = n.getDateFromParams(
        L,
        E,
        D,
        23,
        59,
        59,
        999
      ), se = te, w = `${W(L, 4)}-${W(E, 2)}-${W(D, 2)}`, H = K, T = oe - K, ue = u[R - 1], U = i[R - 1], _e = D === re && E === J && L === C, Me = h && D === 1, ce = h && D === c, Ae = R === 1, Ee = R === d, Ke = K === 1, Ge = K === oe, Te = Rs(L, E, D);
      a.push({
        locale: n,
        id: w,
        position: ++Y,
        label: D.toString(),
        ariaLabel: M.format(new Date(L, E - 1, D)),
        day: D,
        dayFromEnd: N,
        weekday: O,
        weekdayPosition: H,
        weekdayPositionFromEnd: T,
        weekdayOrdinal: B,
        weekdayOrdinalFromEnd: A,
        week: I,
        weekFromEnd: q,
        weekPosition: R,
        weeknumber: ue,
        isoWeeknumber: U,
        month: E,
        year: L,
        date: se,
        startDate: te,
        endDate: ye,
        noonDate: le,
        dayIndex: Te,
        isToday: _e,
        isFirstDay: Me,
        isLastDay: ce,
        isDisabled: !h,
        isFocusable: !h,
        isFocused: !1,
        inMonth: h,
        inPrevMonth: v,
        inNextMonth: b,
        onTop: Ae,
        onBottom: Ee,
        onLeft: Ke,
        onRight: Ge,
        classes: [
          `id-${w}`,
          `day-${D}`,
          `day-from-end-${N}`,
          `weekday-${O}`,
          `weekday-position-${H}`,
          `weekday-ordinal-${B}`,
          `weekday-ordinal-from-end-${A}`,
          `week-${I}`,
          `week-from-end-${q}`,
          {
            "is-today": _e,
            "is-first-day": Me,
            "is-last-day": ce,
            "in-month": h,
            "in-prev-month": v,
            "in-next-month": b,
            "on-top": Ae,
            "on-bottom": Ee,
            "on-left": Ke,
            "on-right": Ge
          }
        ]
      }), h && ce ? (h = !1, b = !0, D = 1, N = c, B = 1, A = Math.floor((c - D) / oe + 1), I = 1, q = r.numWeeks, E = r.month, L = r.year) : (D++, N--, B = Math.floor((D - 1) / oe + 1), A = Math.floor((c - D) / oe + 1));
    }
    I++, q--;
  }
  return a;
}
function Ug(e, t, r, n) {
  const a = e.reduce((s, o, i) => {
    const u = Math.floor(i / 7);
    let c = s[u];
    return c || (c = {
      id: `week-${u + 1}`,
      title: "",
      week: o.week,
      weekPosition: o.weekPosition,
      weeknumber: o.weeknumber,
      isoWeeknumber: o.isoWeeknumber,
      weeknumberDisplay: t ? o.weeknumber : r ? o.isoWeeknumber : void 0,
      days: []
    }, s[u] = c), c.days.push(o), s;
  }, Array(e.length / oe));
  return a.forEach((s) => {
    const o = s.days[0], i = s.days[s.days.length - 1];
    o.month === i.month ? s.title = `${n.formatDate(o.date, "MMMM YYYY")}` : o.year === i.year ? s.title = `${n.formatDate(
      o.date,
      "MMM"
    )} - ${n.formatDate(i.date, "MMM YYYY")}` : s.title = `${n.formatDate(
      o.date,
      "MMM YYYY"
    )} - ${n.formatDate(i.date, "MMM YYYY")}`;
  }), a;
}
function Vg(e, t) {
  return e.days.map((r) => ({
    label: t.formatDate(r.date, t.masks.weekdays),
    weekday: r.weekday
  }));
}
function Kg(e, t) {
  return `${t}.${W(e, 2)}`;
}
function Ts(e, t, r) {
  return ks(
    r.getDateParts(r.toDate(e)),
    Bg[t]
  );
}
function Cs({ day: e, week: t, month: r, year: n }, a, s, o) {
  if (s === "daily" && e) {
    const i = new Date(n, r - 1, e), u = ve(i, a);
    return {
      day: u.getDate(),
      month: u.getMonth() + 1,
      year: u.getFullYear()
    };
  } else if (s === "weekly" && t) {
    const u = o.getMonthParts(r, n).firstDayOfMonth, c = ve(u, (t - 1 + a) * 7), d = o.getDateParts(c);
    return {
      week: d.week,
      month: d.month,
      year: d.year
    };
  } else {
    const i = new Date(n, r - 1, 1), u = hr(i, a);
    return {
      month: u.getMonth() + 1,
      year: u.getFullYear()
    };
  }
}
function Oe(e) {
  return e != null && e.month != null && e.year != null;
}
function Zr(e, t) {
  return !Oe(e) || !Oe(t) ? !1 : (e = e, t = t, e.year !== t.year ? e.year < t.year : e.month && t.month && e.month !== t.month ? e.month < t.month : e.week && t.week && e.week !== t.week ? e.week < t.week : e.day && t.day && e.day !== t.day ? e.day < t.day : !1);
}
function mr(e, t) {
  return !Oe(e) || !Oe(t) ? !1 : (e = e, t = t, e.year !== t.year ? e.year > t.year : e.month && t.month && e.month !== t.month ? e.month > t.month : e.week && t.week && e.week !== t.week ? e.week > t.week : e.day && t.day && e.day !== t.day ? e.day > t.day : !1);
}
function Gg(e, t, r) {
  return (e || !1) && !Zr(e, t) && !mr(e, r);
}
function Zg(e, t) {
  return !e && t || e && !t ? !1 : !e && !t ? !0 : (e = e, t = t, e.year === t.year && e.month === t.month && e.week === t.week && e.day === t.day);
}
function qg(e, t, r, n) {
  if (!Oe(e) || !Oe(t))
    return [];
  const a = [];
  for (; !mr(e, t); )
    a.push(e), e = Cs(e, 1, r, n);
  return a;
}
function Os(e) {
  const { day: t, week: r, month: n, year: a } = e;
  let s = `${a}-${W(n, 2)}`;
  return r && (s = `${s}-w${r}`), t && (s = `${s}-${W(t, 2)}`), s;
}
function Xg(e, t) {
  const { month: r, year: n, showWeeknumbers: a, showIsoWeeknumbers: s } = e, o = new Date(n, r - 1, 15), i = t.getMonthParts(r, n), u = t.getPrevMonthParts(r, n), c = t.getNextMonthParts(r, n), d = zg({ monthComps: i, prevMonthComps: u, nextMonthComps: c }, t), f = Ug(d, a, s, t), v = Vg(f[0], t);
  return {
    id: Os(e),
    month: r,
    year: n,
    monthTitle: t.formatDate(o, t.masks.title),
    shortMonthLabel: t.formatDate(o, "MMM"),
    monthLabel: t.formatDate(o, "MMMM"),
    shortYearLabel: n.toString().substring(2),
    yearLabel: n.toString(),
    monthComps: i,
    prevMonthComps: u,
    nextMonthComps: c,
    days: d,
    weeks: f,
    weekdays: v
  };
}
function Jg(e, t) {
  const { day: r, week: n, view: a, trimWeeks: s } = e, o = {
    ...t,
    ...e,
    title: "",
    viewDays: [],
    viewWeeks: []
  };
  switch (a) {
    case "daily": {
      let i = o.days.find((c) => c.inMonth);
      r ? i = o.days.find((c) => c.day === r && c.inMonth) || i : n && (i = o.days.find((c) => c.week === n && c.inMonth));
      const u = o.weeks[i.week - 1];
      o.viewWeeks = [u], o.viewDays = [i], o.week = i.week, o.weekTitle = u.title, o.day = i.day, o.dayTitle = i.ariaLabel, o.title = o.dayTitle;
      break;
    }
    case "weekly": {
      o.week = n || 1;
      const i = o.weeks[o.week - 1];
      o.viewWeeks = [i], o.viewDays = i.days, o.weekTitle = i.title, o.title = o.weekTitle;
      break;
    }
    default: {
      o.title = o.monthTitle, o.viewWeeks = o.weeks.slice(
        0,
        s ? o.monthComps.numWeeks : void 0
      ), o.viewDays = o.days;
      break;
    }
  }
  return o;
}
class Ya {
  constructor(t, r, n) {
    k(this, "keys", []), k(this, "store", {}), this.size = t, this.createKey = r, this.createItem = n;
  }
  get(...t) {
    const r = this.createKey(...t);
    return this.store[r];
  }
  getOrSet(...t) {
    const r = this.createKey(...t);
    if (this.store[r])
      return this.store[r];
    const n = this.createItem(...t);
    if (this.keys.length >= this.size) {
      const a = this.keys.shift();
      a != null && delete this.store[a];
    }
    return this.keys.push(r), this.store[r] = n, n;
  }
}
class lt {
  constructor(t, r = new pr()) {
    k(this, "order"), k(this, "locale"), k(this, "start", null), k(this, "end", null), k(this, "repeat", null);
    var n;
    this.locale = r;
    const { start: a, end: s, span: o, order: i, repeat: u } = t;
    it(a) && (this.start = r.getDateParts(a)), it(s) ? this.end = r.getDateParts(s) : this.start != null && o && (this.end = r.getDateParts(ve(this.start.date, o - 1))), this.order = i ?? 0, u && (this.repeat = new yr(
      {
        from: (n = this.start) == null ? void 0 : n.date,
        ...u
      },
      {
        locale: this.locale
      }
    ));
  }
  static fromMany(t, r) {
    return ($e(t) ? t : [t]).filter((n) => n).map((n) => lt.from(n, r));
  }
  static from(t, r) {
    if (t instanceof lt)
      return t;
    const n = {
      start: null,
      end: null
    };
    return t != null && ($e(t) ? (n.start = t[0] ?? null, n.end = t[1] ?? null) : Fe(t) ? Object.assign(n, t) : (n.start = t, n.end = t)), n.start != null && (n.start = new Date(n.start)), n.end != null && (n.end = new Date(n.end)), new lt(n, r);
  }
  get opts() {
    const { order: t, locale: r } = this;
    return { order: t, locale: r };
  }
  get hasRepeat() {
    return !!this.repeat;
  }
  get isSingleDay() {
    const { start: t, end: r } = this;
    return t && r && t.year === r.year && t.month === r.month && t.day === r.day;
  }
  get isMultiDay() {
    return !this.isSingleDay;
  }
  get daySpan() {
    return this.start == null || this.end == null ? this.hasRepeat ? 1 : 1 / 0 : this.end.dayIndex - this.start.dayIndex;
  }
  startsOnDay(t) {
    var r, n;
    return ((r = this.start) == null ? void 0 : r.dayIndex) === t.dayIndex || !!((n = this.repeat) != null && n.passes(t));
  }
  intersectsDay(t) {
    return this.intersectsDayRange(t, t);
  }
  intersectsRange(t) {
    var r, n;
    return this.intersectsDayRange(
      ((r = t.start) == null ? void 0 : r.dayIndex) ?? -1 / 0,
      ((n = t.end) == null ? void 0 : n.dayIndex) ?? 1 / 0
    );
  }
  intersectsDayRange(t, r) {
    return !(this.start && this.start.dayIndex > r || this.end && this.end.dayIndex < t);
  }
}
class Qg {
  constructor() {
    k(this, "records", {});
  }
  render(t, r, n) {
    var a, s, o, i;
    let u = null;
    const c = n[0].dayIndex, d = n[n.length - 1].dayIndex;
    return r.hasRepeat ? n.forEach((f) => {
      var v, h;
      if (r.startsOnDay(f)) {
        const b = r.daySpan < 1 / 0 ? r.daySpan : 1;
        u = {
          startDay: f.dayIndex,
          startTime: ((v = r.start) == null ? void 0 : v.time) ?? 0,
          endDay: f.dayIndex + b - 1,
          endTime: ((h = r.end) == null ? void 0 : h.time) ?? or
        }, this.getRangeRecords(t).push(u);
      }
    }) : r.intersectsDayRange(c, d) && (u = {
      startDay: ((a = r.start) == null ? void 0 : a.dayIndex) ?? -1 / 0,
      startTime: ((s = r.start) == null ? void 0 : s.time) ?? -1 / 0,
      endDay: ((o = r.end) == null ? void 0 : o.dayIndex) ?? 1 / 0,
      endTime: ((i = r.end) == null ? void 0 : i.time) ?? 1 / 0
    }, this.getRangeRecords(t).push(u)), u;
  }
  getRangeRecords(t) {
    let r = this.records[t.key];
    return r || (r = {
      ranges: [],
      data: t
    }, this.records[t.key] = r), r.ranges;
  }
  getCell(t, r) {
    return this.getCells(r).find((s) => s.data.key === t);
  }
  cellExists(t, r) {
    const n = this.records[t];
    return n == null ? !1 : n.ranges.some(
      (a) => a.startDay <= r && a.endDay >= r
    );
  }
  getCells(t) {
    const r = Object.values(this.records), n = [], { dayIndex: a } = t;
    return r.forEach(({ data: s, ranges: o }) => {
      o.filter((i) => i.startDay <= a && i.endDay >= a).forEach((i) => {
        const u = a === i.startDay, c = a === i.endDay, d = u ? i.startTime : 0, f = new Date(t.startDate.getTime() + d), v = c ? i.endTime : or, h = new Date(t.endDate.getTime() + v), b = d === 0 && v === or, Y = s.order || 0;
        n.push({
          ...i,
          data: s,
          onStart: u,
          onEnd: c,
          startTime: d,
          startDate: f,
          endTime: v,
          endDate: h,
          allDay: b,
          order: Y
        });
      });
    }), n.sort((s, o) => s.order - o.order), n;
  }
}
const Re = {
  // Arabic
  ar: { dow: 7, L: "D/‏M/‏YYYY" },
  // Bulgarian
  bg: { dow: 2, L: "D.MM.YYYY" },
  // Catalan
  ca: { dow: 2, L: "DD/MM/YYYY" },
  // Chinese (China)
  "zh-CN": { dow: 2, L: "YYYY/MM/DD" },
  // Chinese (Taiwan)
  "zh-TW": { dow: 1, L: "YYYY/MM/DD" },
  // Croatian
  hr: { dow: 2, L: "DD.MM.YYYY" },
  // Czech
  cs: { dow: 2, L: "DD.MM.YYYY" },
  // Danish
  da: { dow: 2, L: "DD.MM.YYYY" },
  // Dutch
  nl: { dow: 2, L: "DD-MM-YYYY" },
  // English (US)
  "en-US": { dow: 1, L: "MM/DD/YYYY" },
  // English (Australia)
  "en-AU": { dow: 2, L: "DD/MM/YYYY" },
  // English (Canada)
  "en-CA": { dow: 1, L: "YYYY-MM-DD" },
  // English (Great Britain)
  "en-GB": { dow: 2, L: "DD/MM/YYYY" },
  // English (Ireland)
  "en-IE": { dow: 2, L: "DD-MM-YYYY" },
  // English (New Zealand)
  "en-NZ": { dow: 2, L: "DD/MM/YYYY" },
  // English (South Africa)
  "en-ZA": { dow: 1, L: "YYYY/MM/DD" },
  // Esperanto
  eo: { dow: 2, L: "YYYY-MM-DD" },
  // Estonian
  et: { dow: 2, L: "DD.MM.YYYY" },
  // Finnish
  fi: { dow: 2, L: "DD.MM.YYYY" },
  // French
  fr: { dow: 2, L: "DD/MM/YYYY" },
  // French (Canada)
  "fr-CA": { dow: 1, L: "YYYY-MM-DD" },
  // French (Switzerland)
  "fr-CH": { dow: 2, L: "DD.MM.YYYY" },
  // German
  de: { dow: 2, L: "DD.MM.YYYY" },
  // Hebrew
  he: { dow: 1, L: "DD.MM.YYYY" },
  // Indonesian
  id: { dow: 2, L: "DD/MM/YYYY" },
  // Italian
  it: { dow: 2, L: "DD/MM/YYYY" },
  // Japanese
  ja: { dow: 1, L: "YYYY年M月D日" },
  // Korean
  ko: { dow: 1, L: "YYYY.MM.DD" },
  // Latvian
  lv: { dow: 2, L: "DD.MM.YYYY" },
  // Lithuanian
  lt: { dow: 2, L: "DD.MM.YYYY" },
  // Macedonian
  mk: { dow: 2, L: "D.MM.YYYY" },
  // Norwegian
  nb: { dow: 2, L: "D. MMMM YYYY" },
  nn: { dow: 2, L: "D. MMMM YYYY" },
  // Polish
  pl: { dow: 2, L: "DD.MM.YYYY" },
  // Portuguese
  pt: { dow: 2, L: "DD/MM/YYYY" },
  // Romanian
  ro: { dow: 2, L: "DD.MM.YYYY" },
  // Russian
  ru: { dow: 2, L: "DD.MM.YYYY" },
  // Slovak
  sk: { dow: 2, L: "DD.MM.YYYY" },
  // Spanish (Spain)
  "es-ES": { dow: 2, L: "DD/MM/YYYY" },
  // Spanish (Mexico)
  "es-MX": { dow: 2, L: "DD/MM/YYYY" },
  // Swedish
  sv: { dow: 2, L: "YYYY-MM-DD" },
  // Thai
  th: { dow: 1, L: "DD/MM/YYYY" },
  // Turkish
  tr: { dow: 2, L: "DD.MM.YYYY" },
  // Ukrainian
  uk: { dow: 2, L: "DD.MM.YYYY" },
  // Vietnam
  vi: { dow: 2, L: "DD/MM/YYYY" }
};
Re.en = Re["en-US"];
Re.es = Re["es-ES"];
Re.no = Re.nb;
Re.zh = Re["zh-CN"];
const e1 = Object.entries(Re).reduce(
  (e, [t, { dow: r, L: n }]) => (e[t] = {
    id: t,
    firstDayOfWeek: r,
    masks: { L: n }
  }, e),
  {}
), t1 = "MMMM YYYY", r1 = "W", n1 = "MMM", a1 = "h A", s1 = [
  "L",
  "YYYY-MM-DD",
  "YYYY/MM/DD"
], o1 = [
  "L h:mm A",
  "YYYY-MM-DD h:mm A",
  "YYYY/MM/DD h:mm A"
], i1 = [
  "L HH:mm",
  "YYYY-MM-DD HH:mm",
  "YYYY/MM/DD HH:mm"
], l1 = [
  "h:mm A"
], u1 = [
  "HH:mm"
], c1 = "WWW, MMM D, YYYY", d1 = [
  "L",
  "YYYY-MM-DD",
  "YYYY/MM/DD"
], f1 = "iso", v1 = "YYYY-MM-DDTHH:mm:ss.SSSZ", h1 = {
  title: t1,
  weekdays: r1,
  navMonths: n1,
  hours: a1,
  input: s1,
  inputDateTime: o1,
  inputDateTime24hr: i1,
  inputTime: l1,
  inputTime24hr: u1,
  dayPopover: c1,
  data: d1,
  model: f1,
  iso: v1
}, m1 = 300, p1 = 60, y1 = 80, g1 = {
  maxSwipeTime: m1,
  minHorizontalSwipeDistance: p1,
  maxVerticalSwipeDistance: y1
}, b1 = {
  componentPrefix: "V",
  color: "blue",
  isDark: !1,
  navVisibility: "click",
  titlePosition: "center",
  transition: "slide-h",
  touch: g1,
  masks: h1,
  locales: e1,
  datePicker: {
    updateOnInput: !0,
    inputDebounce: 1e3,
    popover: {
      visibility: "hover-focus",
      placement: "bottom-start",
      isInteractive: !0
    }
  }
}, qr = tn(b1), D1 = m(() => Wm(qr.locales, (e) => (e.masks = Rt(e.masks, qr.masks), e))), Ue = (e) => typeof window < "u" && _s(window.__vcalendar__, e) ? Xe(window.__vcalendar__, e) : Xe(qr, e), w1 = 12, $1 = 5;
function _1(e, t) {
  const r = new Intl.DateTimeFormat().resolvedOptions().locale;
  let n;
  Ce(e) ? n = e : _s(e, "id") && (n = e.id), n = (n || r).toLowerCase();
  const a = Object.keys(t), s = (u) => a.find((c) => c.toLowerCase() === u);
  n = s(n) || s(n.substring(0, 2)) || r;
  const o = {
    ...t["en-IE"],
    ...t[n],
    id: n,
    monthCacheSize: w1,
    pageCacheSize: $1
  };
  return Fe(e) ? Rt(e, o) : o;
}
class pr {
  constructor(t = void 0, r) {
    k(this, "id"), k(this, "daysInWeek"), k(this, "firstDayOfWeek"), k(this, "masks"), k(this, "timezone"), k(this, "hourLabels"), k(this, "dayNames"), k(this, "dayNamesShort"), k(this, "dayNamesShorter"), k(this, "dayNamesNarrow"), k(this, "monthNames"), k(this, "monthNamesShort"), k(this, "relativeTimeNames"), k(this, "amPm", ["am", "pm"]), k(this, "monthCache"), k(this, "pageCache");
    const { id: n, firstDayOfWeek: a, masks: s, monthCacheSize: o, pageCacheSize: i } = _1(t, D1.value);
    this.monthCache = new Ya(
      o,
      U1,
      V1
    ), this.pageCache = new Ya(i, Os, Xg), this.id = n, this.daysInWeek = oe, this.firstDayOfWeek = ag(a, 1, oe), this.masks = s, this.timezone = r || void 0, this.hourLabels = this.getHourLabels(), this.dayNames = Wr("long", this.id), this.dayNamesShort = Wr("short", this.id), this.dayNamesShorter = this.dayNamesShort.map((u) => u.substring(0, 2)), this.dayNamesNarrow = Wr("narrow", this.id), this.monthNames = Ia("long", this.id), this.monthNamesShort = Ia("short", this.id), this.relativeTimeNames = Z1(this.id);
  }
  formatDate(t, r) {
    return eb(t, r, this);
  }
  parseDate(t, r) {
    return Aa(t, r, this);
  }
  toDate(t, r = {}) {
    const n = /* @__PURE__ */ new Date(NaN);
    let a = n;
    const { fillDate: s, mask: o, patch: i, rules: u } = r;
    if (ke(t) ? (r.type = "number", a = /* @__PURE__ */ new Date(+t)) : Ce(t) ? (r.type = "string", a = t ? Aa(t, o || "iso", this) : n) : it(t) ? (r.type = "date", a = new Date(t.getTime())) : Dn(t) && (r.type = "object", a = this.getDateFromParts(t)), a && (i || u)) {
      let c = this.getDateParts(a);
      if (i && s != null) {
        const d = this.getDateParts(this.toDate(s));
        c = this.getDateParts(
          this.toDate({ ...d, ...ks(c, N1[i]) })
        );
      }
      u && (c = Q1(c, u)), a = this.getDateFromParts(c);
    }
    return a || n;
  }
  toDateOrNull(t, r = {}) {
    const n = this.toDate(t, r);
    return isNaN(n.getTime()) ? null : n;
  }
  fromDate(t, { type: r, mask: n } = {}) {
    switch (r) {
      case "number":
        return t ? t.getTime() : NaN;
      case "string":
        return t ? this.formatDate(t, n || "iso") : "";
      case "object":
        return t ? this.getDateParts(t) : null;
      default:
        return t ? new Date(t) : null;
    }
  }
  range(t) {
    return lt.from(t, this);
  }
  ranges(t) {
    return lt.fromMany(t, this);
  }
  getDateParts(t) {
    return z1(t, this);
  }
  getDateFromParts(t) {
    return Ws(t, this.timezone);
  }
  getDateFromParams(t, r, n, a, s, o, i) {
    return this.getDateFromParts({
      year: t,
      month: r,
      day: n,
      hours: a,
      minutes: s,
      seconds: o,
      milliseconds: i
    });
  }
  getPage(t) {
    const r = this.pageCache.getOrSet(t, this);
    return Jg(t, r);
  }
  getMonthParts(t, r) {
    const { firstDayOfWeek: n } = this;
    return this.monthCache.getOrSet(t, r, n);
  }
  getThisMonthParts() {
    const t = /* @__PURE__ */ new Date();
    return this.getMonthParts(
      t.getMonth() + 1,
      t.getFullYear()
    );
  }
  getPrevMonthParts(t, r) {
    return t === 1 ? this.getMonthParts(12, r - 1) : this.getMonthParts(t - 1, r);
  }
  getNextMonthParts(t, r) {
    return t === 12 ? this.getMonthParts(1, r + 1) : this.getMonthParts(t + 1, r);
  }
  getHourLabels() {
    return G1().map((t) => this.formatDate(t, this.masks.hours));
  }
  getDayId(t) {
    return this.formatDate(t, "YYYY-MM-DD");
  }
}
var st = /* @__PURE__ */ ((e) => (e.Any = "any", e.All = "all", e))(st || {}), Ss = /* @__PURE__ */ ((e) => (e.Days = "days", e.Weeks = "weeks", e.Months = "months", e.Years = "years", e))(Ss || {}), Is = /* @__PURE__ */ ((e) => (e.Days = "days", e.Weekdays = "weekdays", e.Weeks = "weeks", e.Months = "months", e.Years = "years", e))(Is || {}), As = /* @__PURE__ */ ((e) => (e.OrdinalWeekdays = "ordinalWeekdays", e))(As || {});
class M1 {
  constructor(t, r, n) {
    k(this, "validated", !0), this.type = t, this.interval = r, this.from = n, this.from || (console.error(
      'A valid "from" date is required for date interval rule. This rule will be skipped.'
    ), this.validated = !1);
  }
  passes(t) {
    if (!this.validated)
      return !0;
    const { date: r } = t;
    switch (this.type) {
      case "days":
        return wn(this.from.date, r) % this.interval === 0;
      case "weeks":
        return j1(this.from.date, r) % this.interval === 0;
      case "months":
        return B1(this.from.date, r) % this.interval === 0;
      case "years":
        return Hs(this.from.date, r) % this.interval === 0;
      default:
        return !1;
    }
  }
}
class bt {
  constructor(t, r, n, a) {
    k(this, "components", []), this.type = t, this.validator = n, this.getter = a, this.components = this.normalizeComponents(r);
  }
  static create(t, r) {
    switch (t) {
      case "days":
        return new k1(r);
      case "weekdays":
        return new Y1(r);
      case "weeks":
        return new P1(r);
      case "months":
        return new T1(r);
      case "years":
        return new C1(r);
    }
  }
  normalizeComponents(t) {
    if (this.validator(t))
      return [t];
    if (!$e(t))
      return [];
    const r = [];
    return t.forEach((n) => {
      if (!this.validator(n)) {
        console.error(
          `Component value ${n} in invalid for "${this.type}" rule. This rule will be skipped.`
        );
        return;
      }
      r.push(n);
    }), r;
  }
  passes(t) {
    return this.getter(t).some((a) => this.components.includes(a));
  }
}
class k1 extends bt {
  constructor(t) {
    super(
      "days",
      t,
      I1,
      ({ day: r, dayFromEnd: n }) => [r, -n]
    );
  }
}
class Y1 extends bt {
  constructor(t) {
    super(
      "weekdays",
      t,
      Xr,
      ({ weekday: r }) => [r]
    );
  }
}
class P1 extends bt {
  constructor(t) {
    super(
      "weeks",
      t,
      A1,
      ({ week: r, weekFromEnd: n }) => [r, -n]
    );
  }
}
class T1 extends bt {
  constructor(t) {
    super("months", t, E1, ({ month: r }) => [
      r
    ]);
  }
}
class C1 extends bt {
  constructor(t) {
    super("years", t, ke, ({ year: r }) => [r]);
  }
}
class O1 {
  constructor(t, r) {
    k(this, "components"), this.type = t, this.components = this.normalizeComponents(r);
  }
  normalizeArrayConfig(t) {
    const r = [];
    return t.forEach((n, a) => {
      if (ke(n)) {
        if (a === 0)
          return;
        if (!Pa(t[0])) {
          console.error(
            `Ordinal range for "${this.type}" rule is from -5 to -1 or 1 to 5. This rule will be skipped.`
          );
          return;
        }
        if (!Xr(n)) {
          console.error(
            `Acceptable range for "${this.type}" rule is from 1 to 5. This rule will be skipped`
          );
          return;
        }
        r.push([t[0], n]);
      } else $e(n) && r.push(...this.normalizeArrayConfig(n));
    }), r;
  }
  normalizeComponents(t) {
    const r = [];
    return t.forEach((n, a) => {
      if (ke(n)) {
        if (a === 0)
          return;
        if (!Pa(t[0])) {
          console.error(
            `Ordinal range for "${this.type}" rule is from -5 to -1 or 1 to 5. This rule will be skipped.`
          );
          return;
        }
        if (!Xr(n)) {
          console.error(
            `Acceptable range for "${this.type}" rule is from 1 to 5. This rule will be skipped`
          );
          return;
        }
        r.push([t[0], n]);
      } else $e(n) && r.push(...this.normalizeArrayConfig(n));
    }), r;
  }
  passes(t) {
    const { weekday: r, weekdayOrdinal: n, weekdayOrdinalFromEnd: a } = t;
    return this.components.some(
      ([s, o]) => (s === n || s === -a) && r === o
    );
  }
}
class S1 {
  constructor(t) {
    k(this, "type", "function"), k(this, "validated", !0), this.fn = t, Qe(t) || (console.error(
      "The function rule requires a valid function. This rule will be skipped."
    ), this.validated = !1);
  }
  passes(t) {
    return this.validated ? this.fn(t) : !0;
  }
}
class yr {
  constructor(t, r = {}, n) {
    k(this, "validated", !0), k(this, "config"), k(this, "type", st.Any), k(this, "from"), k(this, "until"), k(this, "rules", []), k(this, "locale", new pr()), this.parent = n, r.locale && (this.locale = r.locale), this.config = t, Qe(t) ? (this.type = st.All, this.rules = [new S1(t)]) : $e(t) ? (this.type = st.Any, this.rules = t.map((a) => new yr(a, r, this))) : Fe(t) ? (this.type = st.All, this.from = t.from ? this.locale.getDateParts(t.from) : n == null ? void 0 : n.from, this.until = t.until ? this.locale.getDateParts(t.until) : n == null ? void 0 : n.until, this.rules = this.getObjectRules(t)) : (console.error("Rule group configuration must be an object or an array."), this.validated = !1);
  }
  getObjectRules(t) {
    const r = [];
    if (t.every && (Ce(t.every) && (t.every = [1, `${t.every}s`]), $e(t.every))) {
      const [n = 1, a = Ss.Days] = t.every;
      r.push(new M1(a, n, this.from));
    }
    return Object.values(Is).forEach((n) => {
      n in t && r.push(bt.create(n, t[n]));
    }), Object.values(As).forEach((n) => {
      n in t && r.push(new O1(n, t[n]));
    }), t.on != null && ($e(t.on) || (t.on = [t.on]), r.push(
      new yr(t.on, { locale: this.locale }, this.parent)
    )), r;
  }
  passes(t) {
    return this.validated ? this.from && t.dayIndex <= this.from.dayIndex || this.until && t.dayIndex >= this.until.dayIndex ? !1 : this.type === st.Any ? this.rules.some((r) => r.passes(t)) : this.rules.every((r) => r.passes(t)) : !0;
  }
}
function I1(e) {
  return ke(e) ? e >= 1 && e <= 31 : !1;
}
function Xr(e) {
  return ke(e) ? e >= 1 && e <= 7 : !1;
}
function A1(e) {
  return ke(e) ? e >= -6 && e <= -1 || e >= 1 && e <= 6 : !1;
}
function E1(e) {
  return ke(e) ? e >= 1 && e <= 12 : !1;
}
function Pa(e) {
  return !(!ke(e) || e < -5 || e > 5 || e === 0);
}
const N1 = {
  dateTime: [
    "year",
    "month",
    "day",
    "hours",
    "minutes",
    "seconds",
    "milliseconds"
  ],
  date: ["year", "month", "day"],
  time: ["hours", "minutes", "seconds", "milliseconds"]
}, oe = 7, L1 = 6, Es = 1e3, Ns = Es * 60, Ls = Ns * 60, or = Ls * 24, x1 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], F1 = ["L", "iso"], Et = {
  milliseconds: [0, 999, 3],
  seconds: [0, 59, 2],
  minutes: [0, 59, 2],
  hours: [0, 23, 2]
}, xs = /d{1,2}|W{1,4}|M{1,4}|YY(?:YY)?|S{1,3}|Do|Z{1,4}|([HhMsDm])\1?|[aA]|"[^"]*"|'[^']*'/g, R1 = /\[([^]*?)\]/gm, Ta = {
  D(e) {
    return e.day;
  },
  DD(e) {
    return W(e.day, 2);
  },
  // Do(d: DateParts, l: Locale) {
  //   return l.DoFn(d.day);
  // },
  d(e) {
    return e.weekday - 1;
  },
  dd(e) {
    return W(e.weekday - 1, 2);
  },
  W(e, t) {
    return t.dayNamesNarrow[e.weekday - 1];
  },
  WW(e, t) {
    return t.dayNamesShorter[e.weekday - 1];
  },
  WWW(e, t) {
    return t.dayNamesShort[e.weekday - 1];
  },
  WWWW(e, t) {
    return t.dayNames[e.weekday - 1];
  },
  M(e) {
    return e.month;
  },
  MM(e) {
    return W(e.month, 2);
  },
  MMM(e, t) {
    return t.monthNamesShort[e.month - 1];
  },
  MMMM(e, t) {
    return t.monthNames[e.month - 1];
  },
  YY(e) {
    return String(e.year).substr(2);
  },
  YYYY(e) {
    return W(e.year, 4);
  },
  h(e) {
    return e.hours % 12 || 12;
  },
  hh(e) {
    return W(e.hours % 12 || 12, 2);
  },
  H(e) {
    return e.hours;
  },
  HH(e) {
    return W(e.hours, 2);
  },
  m(e) {
    return e.minutes;
  },
  mm(e) {
    return W(e.minutes, 2);
  },
  s(e) {
    return e.seconds;
  },
  ss(e) {
    return W(e.seconds, 2);
  },
  S(e) {
    return Math.round(e.milliseconds / 100);
  },
  SS(e) {
    return W(Math.round(e.milliseconds / 10), 2);
  },
  SSS(e) {
    return W(e.milliseconds, 3);
  },
  a(e, t) {
    return e.hours < 12 ? t.amPm[0] : t.amPm[1];
  },
  A(e, t) {
    return e.hours < 12 ? t.amPm[0].toUpperCase() : t.amPm[1].toUpperCase();
  },
  Z() {
    return "Z";
  },
  ZZ(e) {
    const t = e.timezoneOffset;
    return `${t > 0 ? "-" : "+"}${W(Math.floor(Math.abs(t) / 60), 2)}`;
  },
  ZZZ(e) {
    const t = e.timezoneOffset;
    return `${t > 0 ? "-" : "+"}${W(
      Math.floor(Math.abs(t) / 60) * 100 + Math.abs(t) % 60,
      4
    )}`;
  },
  ZZZZ(e) {
    const t = e.timezoneOffset;
    return `${t > 0 ? "-" : "+"}${W(Math.floor(Math.abs(t) / 60), 2)}:${W(
      Math.abs(t) % 60,
      2
    )}`;
  }
}, je = /\d\d?/, H1 = /\d{3}/, W1 = /\d{4}/, St = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF/]+(\s*?[\u0600-\u06FF]+){1,2}/i, Ca = () => {
}, Oa = (e) => (t, r, n) => {
  const a = n[e].indexOf(
    r.charAt(0).toUpperCase() + r.substr(1).toLowerCase()
  );
  ~a && (t.month = a);
}, j = {
  D: [
    je,
    (e, t) => {
      e.day = t;
    }
  ],
  Do: [
    new RegExp(je.source + St.source),
    (e, t) => {
      e.day = parseInt(t, 10);
    }
  ],
  d: [je, Ca],
  W: [St, Ca],
  M: [
    je,
    (e, t) => {
      e.month = t - 1;
    }
  ],
  MMM: [St, Oa("monthNamesShort")],
  MMMM: [St, Oa("monthNames")],
  YY: [
    je,
    (e, t) => {
      const n = +(/* @__PURE__ */ new Date()).getFullYear().toString().substr(0, 2);
      e.year = +`${t > 68 ? n - 1 : n}${t}`;
    }
  ],
  YYYY: [
    W1,
    (e, t) => {
      e.year = t;
    }
  ],
  S: [
    /\d/,
    (e, t) => {
      e.milliseconds = t * 100;
    }
  ],
  SS: [
    /\d{2}/,
    (e, t) => {
      e.milliseconds = t * 10;
    }
  ],
  SSS: [
    H1,
    (e, t) => {
      e.milliseconds = t;
    }
  ],
  h: [
    je,
    (e, t) => {
      e.hours = t;
    }
  ],
  m: [
    je,
    (e, t) => {
      e.minutes = t;
    }
  ],
  s: [
    je,
    (e, t) => {
      e.seconds = t;
    }
  ],
  a: [
    St,
    (e, t, r) => {
      const n = t.toLowerCase();
      n === r.amPm[0] ? e.isPm = !1 : n === r.amPm[1] && (e.isPm = !0);
    }
  ],
  Z: [
    /[^\s]*?[+-]\d\d:?\d\d|[^\s]*?Z?/,
    (e, t) => {
      t === "Z" && (t = "+00:00");
      const r = `${t}`.match(/([+-]|\d\d)/gi);
      if (r) {
        const n = +r[1] * 60 + parseInt(r[2], 10);
        e.timezoneOffset = r[0] === "+" ? n : -n;
      }
    }
  ]
};
j.DD = j.D;
j.dd = j.d;
j.WWWW = j.WWW = j.WW = j.W;
j.MM = j.M;
j.mm = j.m;
j.hh = j.H = j.HH = j.h;
j.ss = j.s;
j.A = j.a;
j.ZZZZ = j.ZZZ = j.ZZ = j.Z;
function Fs(e, t) {
  return (xe(e) && e || [
    Ce(e) && e || "YYYY-MM-DD"
  ]).map(
    (r) => F1.reduce(
      (n, a) => n.replace(a, t.masks[a] || ""),
      r
    )
  );
}
function Dn(e) {
  return Fe(e) && "year" in e && "month" in e && "day" in e;
}
function Sa(e, t = 1) {
  const r = e.getDay() + 1, n = r >= t ? t - r : -(7 - (t - r));
  return ve(e, n);
}
function Rs(e, t, r) {
  const n = Date.UTC(e, t - 1, r);
  return wn(/* @__PURE__ */ new Date(0), new Date(n));
}
function wn(e, t) {
  return Math.round((t.getTime() - e.getTime()) / or);
}
function j1(e, t) {
  return Math.ceil(wn(Sa(e), Sa(t)) / 7);
}
function Hs(e, t) {
  return t.getUTCFullYear() - e.getUTCFullYear();
}
function B1(e, t) {
  return Hs(e, t) * 12 + (t.getMonth() - e.getMonth());
}
function Ws(e, t = "") {
  const r = /* @__PURE__ */ new Date(), {
    year: n = r.getFullYear(),
    month: a = r.getMonth() + 1,
    day: s = r.getDate(),
    hours: o = 0,
    minutes: i = 0,
    seconds: u = 0,
    milliseconds: c = 0
  } = e;
  if (t) {
    const d = `${W(n, 4)}-${W(a, 2)}-${W(s, 2)}T${W(
      o,
      2
    )}:${W(i, 2)}:${W(u, 2)}.${W(c, 3)}`;
    return wg(d, { timeZone: t });
  }
  return new Date(n, a - 1, s, o, i, u, c);
}
function z1(e, t) {
  let r = new Date(e.getTime());
  t.timezone && (r = new Date(
    e.toLocaleString("en-US", { timeZone: t.timezone })
  ), r.setMilliseconds(e.getMilliseconds()));
  const n = r.getMilliseconds(), a = r.getSeconds(), s = r.getMinutes(), o = r.getHours(), i = n + a * Es + s * Ns + o * Ls, u = r.getMonth() + 1, c = r.getFullYear(), d = t.getMonthParts(u, c), f = r.getDate(), v = d.numDays - f + 1, h = r.getDay() + 1, b = Math.floor((f - 1) / 7 + 1), Y = Math.floor((d.numDays - f) / 7 + 1), M = Math.ceil(
    (f + Math.abs(d.firstWeekday - d.firstDayOfWeek)) / 7
  ), D = d.numWeeks - M + 1, N = d.weeknumbers[M], B = Rs(c, u, f);
  return {
    milliseconds: n,
    seconds: a,
    minutes: s,
    hours: o,
    time: i,
    day: f,
    dayFromEnd: v,
    weekday: h,
    weekdayOrdinal: b,
    weekdayOrdinalFromEnd: Y,
    week: M,
    weekFromEnd: D,
    weeknumber: N,
    month: u,
    year: c,
    date: r,
    dateTime: r.getTime(),
    dayIndex: B,
    timezoneOffset: 0,
    isValid: !0
  };
}
function U1(e, t, r) {
  return `${t}-${e}-${r}`;
}
function V1(e, t, r) {
  const n = t % 4 === 0 && t % 100 !== 0 || t % 400 === 0, a = new Date(t, e - 1, 1), s = a.getDay() + 1, o = e === 2 && n ? 29 : x1[e - 1], i = r - 1, u = Eg(a, {
    weekStartsOn: i
  }), c = [], d = [];
  for (let f = 0; f < u; f++) {
    const v = ve(a, f * 7);
    c.push(Fg(v, { weekStartsOn: i })), d.push(jg(v));
  }
  return {
    firstDayOfWeek: r,
    firstDayOfMonth: a,
    inLeapYear: n,
    firstWeekday: s,
    numDays: o,
    numWeeks: u,
    month: e,
    year: t,
    weeknumbers: c,
    isoWeeknumbers: d
  };
}
function K1() {
  const e = [];
  for (let a = 0; a < oe; a++)
    e.push(
      Ws({
        year: 2020,
        month: 1,
        day: 5 + a,
        hours: 12
      })
    );
  return e;
}
function Wr(e, t = void 0) {
  const r = new Intl.DateTimeFormat(t, {
    weekday: e
  });
  return K1().map((n) => r.format(n));
}
function G1() {
  const e = [];
  for (let t = 0; t <= 24; t++)
    e.push(new Date(2e3, 0, 1, t));
  return e;
}
function Z1(e = void 0) {
  const t = [
    "second",
    "minute",
    "hour",
    "day",
    "week",
    "month",
    "quarter",
    "year"
  ], r = new Intl.RelativeTimeFormat(e);
  return t.reduce((n, a) => {
    const s = r.formatToParts(100, a);
    return n[a] = s[1].unit, n;
  }, {});
}
function js() {
  const e = [];
  for (let t = 0; t < 12; t++)
    e.push(new Date(2e3, t, 15));
  return e;
}
function Ia(e, t = void 0) {
  const r = new Intl.DateTimeFormat(t, {
    month: e,
    timeZone: "UTC"
  });
  return js().map((n) => r.format(n));
}
function q1(e, t, r) {
  return ke(t) ? t === e : $e(t) ? t.includes(e) : Qe(t) ? t(e, r) : !(t.min != null && t.min > e || t.max != null && t.max < e || t.interval != null && e % t.interval !== 0);
}
function Nt(e, t, r) {
  const n = [], [a, s, o] = t;
  for (let i = a; i <= s; i++)
    (r == null || q1(i, r, e)) && n.push({
      value: i,
      label: W(i, o)
    });
  return n;
}
function X1(e, t) {
  return {
    milliseconds: Nt(
      e,
      Et.milliseconds,
      t.milliseconds
    ),
    seconds: Nt(e, Et.seconds, t.seconds),
    minutes: Nt(e, Et.minutes, t.minutes),
    hours: Nt(e, Et.hours, t.hours)
  };
}
function J1(e, t, r, n) {
  const s = Nt(e, t, n).reduce((o, i) => {
    if (i.disabled)
      return o;
    if (isNaN(o))
      return i.value;
    const u = Math.abs(o - r);
    return Math.abs(i.value - r) < u ? i.value : o;
  }, NaN);
  return isNaN(s) ? r : s;
}
function Q1(e, t) {
  const r = { ...e };
  return Object.entries(t).forEach(([n, a]) => {
    const s = Et[n], o = e[n];
    r[n] = J1(
      e,
      s,
      o,
      a
    );
  }), r;
}
function Aa(e, t, r) {
  return Fs(t, r).map((a) => {
    if (typeof a != "string")
      throw new Error("Invalid mask");
    let s = e;
    if (s.length > 1e3)
      return !1;
    let o = !0;
    const i = {};
    if (a.replace(xs, (d) => {
      if (j[d]) {
        const f = j[d], v = s.search(f[0]);
        ~v ? s.replace(f[0], (h) => (f[1](i, h, r), s = s.substr(v + h.length), h)) : o = !1;
      }
      return j[d] ? "" : d.slice(1, d.length - 1);
    }), !o)
      return !1;
    const u = /* @__PURE__ */ new Date();
    i.hours != null && (i.isPm === !0 && +i.hours != 12 ? i.hours = +i.hours + 12 : i.isPm === !1 && +i.hours == 12 && (i.hours = 0));
    let c;
    return i.timezoneOffset != null ? (i.minutes = +(i.minutes || 0) - +i.timezoneOffset, c = new Date(
      Date.UTC(
        i.year || u.getFullYear(),
        i.month || 0,
        i.day || 1,
        i.hours || 0,
        i.minutes || 0,
        i.seconds || 0,
        i.milliseconds || 0
      )
    )) : c = r.getDateFromParts({
      year: i.year || u.getFullYear(),
      month: (i.month || 0) + 1,
      day: i.day || 1,
      hours: i.hours || 0,
      minutes: i.minutes || 0,
      seconds: i.seconds || 0,
      milliseconds: i.milliseconds || 0
    }), c;
  }).find((a) => a) || new Date(e);
}
function eb(e, t, r) {
  if (e == null)
    return "";
  let n = Fs(t, r)[0];
  /Z$/.test(n) && (r.timezone = "utc");
  const a = [];
  n = n.replace(R1, (o, i) => (a.push(i), "??"));
  const s = r.getDateParts(e);
  return n = n.replace(
    xs,
    (o) => o in Ta ? Ta[o](s, r) : o.slice(1, o.length - 1)
  ), n.replace(/\?\?/g, () => a.shift());
}
let tb = 0;
class Bs {
  constructor(t, r, n) {
    k(this, "key", ""), k(this, "hashcode", ""), k(this, "highlight", null), k(this, "content", null), k(this, "dot", null), k(this, "bar", null), k(this, "event", null), k(this, "popover", null), k(this, "customData", null), k(this, "ranges"), k(this, "hasRanges", !1), k(this, "order", 0), k(this, "pinPage", !1), k(this, "maxRepeatSpan", 0), k(this, "locale");
    const { dates: a } = Object.assign(
      this,
      { hashcode: "", order: 0, pinPage: !1 },
      t
    );
    this.key || (this.key = ++tb), this.locale = n, r.normalizeGlyphs(this), this.ranges = n.ranges(a ?? []), this.hasRanges = !!xe(this.ranges), this.maxRepeatSpan = this.ranges.filter((s) => s.hasRepeat).map((s) => s.daySpan).reduce((s, o) => Math.max(s, o), 0);
  }
  intersectsRange({ start: t, end: r }) {
    if (t == null || r == null)
      return !1;
    const n = this.ranges.filter((o) => !o.hasRepeat);
    for (const o of n)
      if (o.intersectsDayRange(t.dayIndex, r.dayIndex))
        return !0;
    const a = this.ranges.filter((o) => o.hasRepeat);
    if (!a.length)
      return !1;
    let s = t;
    for (this.maxRepeatSpan > 1 && (s = this.locale.getDateParts(ve(s.date, -this.maxRepeatSpan))); s.dayIndex <= r.dayIndex; ) {
      for (const o of a)
        if (o.startsOnDay(s))
          return !0;
      s = this.locale.getDateParts(ve(s.date, 1));
    }
    return !1;
  }
}
function Jr(e) {
  document && document.dispatchEvent(
    new CustomEvent("show-popover", {
      detail: e
    })
  );
}
function Ht(e) {
  document && document.dispatchEvent(
    new CustomEvent("hide-popover", {
      detail: e
    })
  );
}
function zs(e) {
  document && document.dispatchEvent(
    new CustomEvent("toggle-popover", {
      detail: e
    })
  );
}
function Us(e) {
  const { visibility: t } = e, r = t === "click", n = t === "hover", a = t === "hover-focus", s = t === "focus";
  e.autoHide = !r;
  let o = !1, i = !1;
  const u = (b) => {
    r && (zs({
      ...e,
      target: e.target || b.currentTarget
    }), b.stopPropagation());
  }, c = (b) => {
    o || (o = !0, (n || a) && Jr({
      ...e,
      target: e.target || b.currentTarget
    }));
  }, d = () => {
    o && (o = !1, (n || a && !i) && Ht(e));
  }, f = (b) => {
    i || (i = !0, (s || a) && Jr({
      ...e,
      target: e.target || b.currentTarget
    }));
  }, v = (b) => {
    i && !ar(b.currentTarget, b.relatedTarget) && (i = !1, (s || a && !o) && Ht(e));
  }, h = {};
  switch (e.visibility) {
    case "click":
      h.click = u;
      break;
    case "hover":
      h.mousemove = c, h.mouseleave = d;
      break;
    case "focus":
      h.focusin = f, h.focusout = v;
      break;
    case "hover-focus":
      h.mousemove = c, h.mouseleave = d, h.focusin = f, h.focusout = v;
      break;
  }
  return h;
}
const Ea = (e) => {
  const t = cr(e);
  if (t == null)
    return;
  const r = t.popoverHandlers;
  !r || !r.length || (r.forEach((n) => n()), delete t.popoverHandlers);
}, Na = (e, t) => {
  const r = cr(e);
  if (r == null)
    return;
  const n = [], a = Us(t);
  Object.entries(a).forEach(([s, o]) => {
    n.push(ze(r, s, o));
  }), r.popoverHandlers = n;
}, Vs = {
  mounted(e, t) {
    const { value: r } = t;
    r && Na(e, r);
  },
  updated(e, t) {
    const { oldValue: r, value: n } = t, a = r == null ? void 0 : r.visibility, s = n == null ? void 0 : n.visibility;
    a !== s && (a && (Ea(e), s || Ht(r)), s && Na(e, n));
  },
  unmounted(e) {
    Ea(e);
  }
}, rb = (e, t, {
  maxSwipeTime: r,
  minHorizontalSwipeDistance: n,
  maxVerticalSwipeDistance: a
}) => {
  if (!e || !e.addEventListener || !Qe(t))
    return null;
  let s = 0, o = 0, i = null, u = !1;
  function c(f) {
    const v = f.changedTouches[0];
    s = v.screenX, o = v.screenY, i = (/* @__PURE__ */ new Date()).getTime(), u = !0;
  }
  function d(f) {
    if (!u || !i)
      return;
    u = !1;
    const v = f.changedTouches[0], h = v.screenX - s, b = v.screenY - o;
    if ((/* @__PURE__ */ new Date()).getTime() - i < r && Math.abs(h) >= n && Math.abs(b) <= a) {
      const M = { toLeft: !1, toRight: !1 };
      h < 0 ? M.toLeft = !0 : M.toRight = !0, t(M);
    }
  }
  return ze(e, "touchstart", c, { passive: !0 }), ze(e, "touchend", d, { passive: !0 }), () => {
    Be(e, "touchstart", c), Be(e, "touchend", d);
  };
}, ir = {}, nb = (e, t = 10) => {
  ir[e] = Date.now() + t;
}, ab = (e, t) => {
  if (e in ir) {
    const r = ir[e];
    if (Date.now() < r)
      return;
    delete ir[e];
  }
  t();
};
function Ks() {
  return typeof window < "u";
}
function sb(e) {
  return Ks() && e in window;
}
function ob(e) {
  const t = G(!1), r = m(() => t.value ? "dark" : "light");
  let n, a;
  function s(h) {
    t.value = h.matches;
  }
  function o() {
    sb("matchMedia") && (n = window.matchMedia("(prefers-color-scheme: dark)"), n.addEventListener("change", s), t.value = n.matches);
  }
  function i() {
    const { selector: h = ":root", darkClass: b = "dark" } = e.value, Y = document.querySelector(h);
    t.value = Y.classList.contains(b);
  }
  function u(h) {
    const { selector: b = ":root", darkClass: Y = "dark" } = h;
    if (Ks() && b && Y) {
      const M = document.querySelector(b);
      M && (a = new MutationObserver(i), a.observe(M, {
        attributes: !0,
        attributeFilter: ["class"]
      }), t.value = M.classList.contains(Y));
    }
  }
  function c() {
    f();
    const h = typeof e.value;
    h === "string" && e.value.toLowerCase() === "system" ? o() : h === "object" ? u(e.value) : t.value = !!e.value;
  }
  const d = fe(() => e.value, () => c(), {
    immediate: !0
  });
  function f() {
    n && (n.removeEventListener("change", s), n = void 0), a && (a.disconnect(), a = void 0);
  }
  function v() {
    f(), d();
  }
  return Qr(() => v()), {
    isDark: t,
    displayMode: r,
    cleanup: v
  };
}
const ib = ["base", "start", "end", "startEnd"], lb = [
  "class",
  "wrapperClass",
  "contentClass",
  "style",
  "contentStyle",
  "color",
  "fillMode"
], ub = { base: {}, start: {}, end: {} };
function $n(e, t, r = ub) {
  let n = e, a = {};
  t === !0 || Ce(t) ? (n = Ce(t) ? t : n, a = { ...r }) : Fe(t) && (ma(t, ib) ? a = { ...t } : a = {
    base: { ...t },
    start: { ...t },
    end: { ...t }
  });
  const s = Rt(
    a,
    { start: a.startEnd, end: a.startEnd },
    r
  );
  return Object.entries(s).forEach(([o, i]) => {
    let u = n;
    i === !0 || Ce(i) ? (u = Ce(i) ? i : u, s[o] = { color: u }) : Fe(i) && (ma(i, lb) ? s[o] = { ...i } : s[o] = {}), Rt(s[o], { color: u });
  }), s;
}
class cb {
  constructor() {
    k(this, "type", "highlight");
  }
  normalizeConfig(t, r) {
    return $n(t, r, {
      base: { fillMode: "light" },
      start: { fillMode: "solid" },
      end: { fillMode: "solid" }
    });
  }
  prepareRender(t) {
    t.highlights = [], t.content || (t.content = []);
  }
  render({ data: t, onStart: r, onEnd: n }, a) {
    const { key: s, highlight: o } = t;
    if (!o)
      return;
    const { highlights: i } = a, { base: u, start: c, end: d } = o;
    r && n ? i.push({
      ...c,
      key: s,
      wrapperClass: `vc-day-layer vc-day-box-center-center vc-attr vc-${c.color}`,
      class: [`vc-highlight vc-highlight-bg-${c.fillMode}`, c.class],
      contentClass: [
        `vc-attr vc-highlight-content-${c.fillMode} vc-${c.color}`,
        c.contentClass
      ]
    }) : r ? (i.push({
      ...u,
      key: `${s}-base`,
      wrapperClass: `vc-day-layer vc-day-box-right-center vc-attr vc-${u.color}`,
      class: [
        `vc-highlight vc-highlight-base-start vc-highlight-bg-${u.fillMode}`,
        u.class
      ]
    }), i.push({
      ...c,
      key: s,
      wrapperClass: `vc-day-layer vc-day-box-center-center vc-attr vc-${c.color}`,
      class: [`vc-highlight vc-highlight-bg-${c.fillMode}`, c.class],
      contentClass: [
        `vc-attr vc-highlight-content-${c.fillMode} vc-${c.color}`,
        c.contentClass
      ]
    })) : n ? (i.push({
      ...u,
      key: `${s}-base`,
      wrapperClass: `vc-day-layer vc-day-box-left-center vc-attr vc-${u.color}`,
      class: [
        `vc-highlight vc-highlight-base-end vc-highlight-bg-${u.fillMode}`,
        u.class
      ]
    }), i.push({
      ...d,
      key: s,
      wrapperClass: `vc-day-layer vc-day-box-center-center vc-attr vc-${d.color}`,
      class: [`vc-highlight vc-highlight-bg-${d.fillMode}`, d.class],
      contentClass: [
        `vc-attr vc-highlight-content-${d.fillMode} vc-${d.color}`,
        d.contentClass
      ]
    })) : i.push({
      ...u,
      key: `${s}-middle`,
      wrapperClass: `vc-day-layer vc-day-box-center-center vc-attr vc-${u.color}`,
      class: [
        `vc-highlight vc-highlight-base-middle vc-highlight-bg-${u.fillMode}`,
        u.class
      ],
      contentClass: [
        `vc-attr vc-highlight-content-${u.fillMode} vc-${u.color}`,
        u.contentClass
      ]
    });
  }
}
class _n {
  constructor(t, r) {
    k(this, "type", ""), k(this, "collectionType", ""), this.type = t, this.collectionType = r;
  }
  normalizeConfig(t, r) {
    return $n(t, r);
  }
  prepareRender(t) {
    t[this.collectionType] = [];
  }
  render({ data: t, onStart: r, onEnd: n }, a) {
    const { key: s } = t, o = t[this.type];
    if (!s || !o)
      return;
    const i = a[this.collectionType], { base: u, start: c, end: d } = o;
    r ? i.push({
      ...c,
      key: s,
      class: [
        `vc-${this.type} vc-${this.type}-start vc-${c.color} vc-attr`,
        c.class
      ]
    }) : n ? i.push({
      ...d,
      key: s,
      class: [
        `vc-${this.type} vc-${this.type}-end vc-${d.color} vc-attr`,
        d.class
      ]
    }) : i.push({
      ...u,
      key: s,
      class: [
        `vc-${this.type} vc-${this.type}-base vc-${u.color} vc-attr`,
        u.class
      ]
    });
  }
}
class db extends _n {
  constructor() {
    super("content", "content");
  }
  normalizeConfig(t, r) {
    return $n("base", r);
  }
}
class fb extends _n {
  constructor() {
    super("dot", "dots");
  }
}
class vb extends _n {
  constructor() {
    super("bar", "bars");
  }
}
class hb {
  constructor(t) {
    k(this, "color"), k(this, "renderers", [
      new db(),
      new cb(),
      new fb(),
      new vb()
    ]), this.color = t;
  }
  normalizeGlyphs(t) {
    this.renderers.forEach((r) => {
      const n = r.type;
      t[n] != null && (t[n] = r.normalizeConfig(this.color, t[n]));
    });
  }
  prepareRender(t = {}) {
    return this.renderers.forEach((r) => {
      r.prepareRender(t);
    }), t;
  }
  render(t, r) {
    this.renderers.forEach((n) => {
      n.render(t, r);
    });
  }
}
const Gs = Symbol("__vc_base_context__"), Zs = {
  color: {
    type: String,
    default: () => Ue("color")
  },
  isDark: {
    type: [Boolean, String, Object],
    default: () => Ue("isDark")
  },
  firstDayOfWeek: Number,
  masks: Object,
  locale: [String, Object],
  timezone: String,
  minDate: null,
  maxDate: null,
  disabledDates: null
};
function qs(e) {
  const t = m(() => e.color ?? ""), r = m(() => e.isDark ?? !1), { displayMode: n } = ob(r), a = m(() => new hb(t.value)), s = m(() => {
    if (e.locale instanceof pr)
      return e.locale;
    const v = Fe(e.locale) ? e.locale : {
      id: e.locale,
      firstDayOfWeek: e.firstDayOfWeek,
      masks: e.masks
    };
    return new pr(v, e.timezone);
  }), o = m(() => s.value.masks), i = m(() => e.minDate), u = m(() => e.maxDate), c = m(() => {
    const v = e.disabledDates ? [...e.disabledDates] : [];
    return i.value != null && v.push({
      start: null,
      end: ve(s.value.toDate(i.value), -1)
    }), u.value != null && v.push({
      start: ve(s.value.toDate(u.value), 1),
      end: null
    }), s.value.ranges(v);
  }), d = m(() => new Bs(
    {
      key: "disabled",
      dates: c.value,
      order: 100
    },
    a.value,
    s.value
  )), f = {
    color: t,
    isDark: r,
    displayMode: n,
    theme: a,
    locale: s,
    masks: o,
    minDate: i,
    maxDate: u,
    disabledDates: c,
    disabledAttribute: d
  };
  return jt(Gs, f), f;
}
function mb(e) {
  return Bt(Gs, () => qs(e), !0);
}
function Xs(e) {
  return `__vc_slot_${e}__`;
}
function Js(e, t = {}) {
  Object.keys(e).forEach((r) => {
    jt(Xs(t[r] ?? r), e[r]);
  });
}
function Qs(e) {
  return Bt(Xs(e), null);
}
const pb = {
  ...Zs,
  view: {
    type: String,
    default: "monthly",
    validator(e) {
      return ["daily", "weekly", "monthly"].includes(e);
    }
  },
  rows: {
    type: Number,
    default: 1
  },
  columns: {
    type: Number,
    default: 1
  },
  step: Number,
  titlePosition: {
    type: String,
    default: () => Ue("titlePosition")
  },
  navVisibility: {
    type: String,
    default: () => Ue("navVisibility")
  },
  showWeeknumbers: [Boolean, String],
  showIsoWeeknumbers: [Boolean, String],
  expanded: Boolean,
  borderless: Boolean,
  transparent: Boolean,
  initialPage: Object,
  initialPagePosition: { type: Number, default: 1 },
  minPage: Object,
  maxPage: Object,
  transition: String,
  attributes: Array,
  trimWeeks: Boolean,
  disablePageSwipe: Boolean
}, yb = [
  "dayclick",
  "daymouseenter",
  "daymouseleave",
  "dayfocusin",
  "dayfocusout",
  "daykeydown",
  "weeknumberclick",
  "transition-start",
  "transition-end",
  "did-move",
  "update:view",
  "update:pages"
], eo = Symbol("__vc_calendar_context__");
function gb(e, { slots: t, emit: r }) {
  const n = G(null), a = G(null), s = G((/* @__PURE__ */ new Date()).getDate()), o = G(!1), i = G(Symbol()), u = G(Symbol()), c = G(e.view), d = G([]), f = G("");
  let v = null, h = null;
  Js(t);
  const {
    theme: b,
    color: Y,
    displayMode: M,
    locale: D,
    masks: N,
    minDate: B,
    maxDate: A,
    disabledAttribute: I,
    disabledDates: q
  } = mb(e), E = m(() => e.rows * e.columns), L = m(() => e.step || E.value), X = m(() => $s(d.value) ?? null), re = m(() => ot(d.value) ?? null), J = m(
    () => e.minPage || (B.value ? T(B.value) : null)
  ), C = m(
    () => e.maxPage || (A.value ? T(A.value) : null)
  ), R = m(() => e.navVisibility), K = m(() => !!e.showWeeknumbers), O = m(() => !!e.showIsoWeeknumbers), te = m(() => c.value === "monthly"), le = m(() => c.value === "weekly"), ye = m(() => c.value === "daily"), se = () => {
    o.value = !0, r("transition-start");
  }, w = () => {
    o.value = !1, r("transition-end"), v && (v.resolve(!0), v = null);
  }, H = (g, l, p = c.value) => Cs(g, l, p, D.value), T = (g) => Ts(g, c.value, D.value), ue = (g) => {
    !I.value || !Ee.value || (g.isDisabled = Ee.value.cellExists(
      I.value.key,
      g.dayIndex
    ));
  }, U = (g) => {
    g.isFocusable = g.inMonth && g.day === s.value;
  }, _e = (g, l) => {
    for (const p of g)
      for (const $ of p.days)
        if (l($) === !1)
          return;
  }, Me = m(
    () => d.value.reduce((g, l) => (g.push(...l.viewDays), g), [])
  ), ce = m(() => {
    const g = [];
    return (e.attributes || []).forEach((l, p) => {
      !l || !l.dates || g.push(
        new Bs(
          {
            ...l,
            order: l.order || 0
          },
          b.value,
          D.value
        )
      );
    }), I.value && g.push(I.value), g;
  }), Ae = m(() => xe(ce.value)), Ee = m(() => {
    const g = new Qg();
    return ce.value.forEach((l) => {
      l.ranges.forEach((p) => {
        g.render(l, p, Me.value);
      });
    }), g;
  }), Ke = m(() => Me.value.reduce((g, l) => (g[l.dayIndex] = { day: l, cells: [] }, g[l.dayIndex].cells.push(...Ee.value.getCells(l)), g), {})), Ge = (g, l) => {
    const p = e.showWeeknumbers || e.showIsoWeeknumbers;
    return p == null ? "" : _m(p) ? p ? "left" : "" : p.startsWith("right") ? l > 1 ? "right" : p : g > 1 ? "left" : p;
  }, Te = () => {
    var g, l;
    if (!Ae.value)
      return null;
    const p = ce.value.find((V) => V.pinPage) || ce.value[0];
    if (!p || !p.hasRanges)
      return null;
    const [$] = p.ranges, S = ((g = $.start) == null ? void 0 : g.date) || ((l = $.end) == null ? void 0 : l.date);
    return S ? T(S) : null;
  }, Ne = () => {
    if (Oe(X.value))
      return X.value;
    const g = Te();
    return Oe(g) ? g : T(/* @__PURE__ */ new Date());
  }, rt = (g, l = {}) => {
    const { view: p = c.value, position: $ = 1, force: S } = l, V = $ > 0 ? 1 - $ : -(E.value + $);
    let de = H(g, V, p), be = H(de, E.value - 1, p);
    return S || (Zr(de, J.value) ? de = J.value : mr(be, C.value) && (de = H(C.value, 1 - E.value)), be = H(de, E.value - 1)), { fromPage: de, toPage: be };
  }, Ut = (g, l, p = "") => {
    if (p === "none" || p === "fade")
      return p;
    if ((g == null ? void 0 : g.view) !== (l == null ? void 0 : l.view))
      return "fade";
    const $ = mr(l, g), S = Zr(l, g);
    return !$ && !S ? "fade" : p === "slide-v" ? S ? "slide-down" : "slide-up" : S ? "slide-right" : "slide-left";
  }, Ze = (g = {}) => new Promise((l, p) => {
    const { position: $ = 1, force: S = !1, transition: V } = g, de = Oe(g.page) ? g.page : Ne(), { fromPage: be } = rt(de, {
      position: $,
      force: S
    }), nt = [];
    for (let at = 0; at < E.value; at++) {
      const Ir = H(be, at), ge = at + 1, Ar = Math.ceil(ge / e.columns), Qt = e.rows - Ar + 1, Pt = ge % e.columns || e.columns, Tt = e.columns - Pt + 1, io = Ge(Pt, Tt);
      nt.push(
        D.value.getPage({
          ...Ir,
          view: c.value,
          titlePosition: e.titlePosition,
          trimWeeks: e.trimWeeks,
          position: ge,
          row: Ar,
          rowFromEnd: Qt,
          column: Pt,
          columnFromEnd: Tt,
          showWeeknumbers: K.value,
          showIsoWeeknumbers: O.value,
          weeknumberPosition: io
        })
      );
    }
    f.value = Ut(
      d.value[0],
      nt[0],
      V
    ), d.value = nt, f.value && f.value !== "none" ? v = {
      resolve: l,
      reject: p
    } : l(!0);
  }), Vt = (g) => {
    const l = X.value ?? T(/* @__PURE__ */ new Date());
    return H(l, g);
  }, Dt = (g, l = {}) => {
    const p = Oe(g) ? g : T(g);
    return Object.assign(
      l,
      rt(p, {
        ...l,
        force: !0
      })
    ), qg(
      l.fromPage,
      l.toPage,
      c.value,
      D.value
    ).map((S) => Gg(S, J.value, C.value)).some((S) => S);
  }, wt = (g, l = {}) => Dt(Vt(g), l), Yr = m(() => wt(-L.value)), Pr = m(() => wt(L.value)), $t = async (g, l = {}) => !l.force && !Dt(g, l) ? !1 : (l.fromPage && !Zg(l.fromPage, X.value) && (Ht({ id: i.value, hideDelay: 0 }), l.view && (nb("view", 10), c.value = l.view), await Ze({
    ...l,
    page: l.fromPage,
    position: 1,
    force: !0
  }), r("did-move", d.value)), !0), _t = (g, l = {}) => $t(Vt(g), l), Kt = () => _t(-L.value), Mt = () => _t(L.value), kt = (g) => {
    const l = te.value ? ".in-month" : "", p = `.id-${D.value.getDayId(g)}${l}`, $ = `${p}.vc-focusable, ${p} .vc-focusable`, S = n.value;
    if (S) {
      const V = S.querySelector($);
      if (V)
        return V.focus(), !0;
    }
    return !1;
  }, Gt = async (g, l = {}) => kt(g) ? !0 : (await $t(g, l), kt(g)), Tr = (g, l) => {
    s.value = g.day, r("dayclick", g, l);
  }, Cr = (g, l) => {
    r("daymouseenter", g, l);
  }, Yt = (g, l) => {
    r("daymouseleave", g, l);
  }, Or = (g, l) => {
    s.value = g.day, a.value = g, g.isFocused = !0, r("dayfocusin", g, l);
  }, Zt = (g, l) => {
    a.value = null, g.isFocused = !1, r("dayfocusout", g, l);
  }, qt = (g, l) => {
    r("daykeydown", g, l);
    const p = g.noonDate;
    let $ = null;
    switch (l.key) {
      case "ArrowLeft": {
        $ = ve(p, -1);
        break;
      }
      case "ArrowRight": {
        $ = ve(p, 1);
        break;
      }
      case "ArrowUp": {
        $ = ve(p, -7);
        break;
      }
      case "ArrowDown": {
        $ = ve(p, 7);
        break;
      }
      case "Home": {
        $ = ve(p, -g.weekdayPosition + 1);
        break;
      }
      case "End": {
        $ = ve(p, g.weekdayPositionFromEnd);
        break;
      }
      case "PageUp": {
        l.altKey ? $ = ka(p, -1) : $ = hr(p, -1);
        break;
      }
      case "PageDown": {
        l.altKey ? $ = ka(p, 1) : $ = hr(p, 1);
        break;
      }
    }
    $ && (l.preventDefault(), Gt($).catch());
  }, Sr = (g) => {
    const l = a.value;
    l != null && qt(l, g);
  }, Xt = (g, l) => {
    r("weeknumberclick", g, l);
  };
  Ze({
    page: e.initialPage,
    position: e.initialPagePosition
  }), gr(() => {
    !e.disablePageSwipe && n.value && (h = rb(
      n.value,
      ({ toLeft: g = !1, toRight: l = !1 }) => {
        g ? Mt() : l && Kt();
      },
      Ue("touch")
    ));
  }), Qr(() => {
    d.value = [], h && h();
  }), fe(
    () => D.value,
    () => {
      Ze();
    }
  ), fe(
    () => E.value,
    () => Ze()
  ), fe(
    () => e.view,
    () => c.value = e.view
  ), fe(
    () => c.value,
    () => {
      ab("view", () => {
        Ze();
      }), r("update:view", c.value);
    }
  ), fe(
    () => s.value,
    () => {
      _e(d.value, (g) => U(g));
    }
  ), Ha(() => {
    r("update:pages", d.value), _e(d.value, (g) => {
      ue(g), U(g);
    });
  });
  const Jt = {
    emit: r,
    containerRef: n,
    focusedDay: a,
    inTransition: o,
    navPopoverId: i,
    dayPopoverId: u,
    view: c,
    pages: d,
    transitionName: f,
    theme: b,
    color: Y,
    displayMode: M,
    locale: D,
    masks: N,
    attributes: ce,
    disabledAttribute: I,
    disabledDates: q,
    attributeContext: Ee,
    days: Me,
    dayCells: Ke,
    count: E,
    step: L,
    firstPage: X,
    lastPage: re,
    canMovePrev: Yr,
    canMoveNext: Pr,
    minPage: J,
    maxPage: C,
    isMonthly: te,
    isWeekly: le,
    isDaily: ye,
    navVisibility: R,
    showWeeknumbers: K,
    showIsoWeeknumbers: O,
    getDateAddress: T,
    canMove: Dt,
    canMoveBy: wt,
    move: $t,
    moveBy: _t,
    movePrev: Kt,
    moveNext: Mt,
    onTransitionBeforeEnter: se,
    onTransitionAfterEnter: w,
    tryFocusDate: kt,
    focusDate: Gt,
    onKeydown: Sr,
    onDayKeydown: qt,
    onDayClick: Tr,
    onDayMouseenter: Cr,
    onDayMouseleave: Yt,
    onDayFocusin: Or,
    onDayFocusout: Zt,
    onWeeknumberClick: Xt
  };
  return jt(eo, Jt), Jt;
}
function tt() {
  const e = Bt(eo);
  if (e)
    return e;
  throw new Error(
    "Calendar context missing. Please verify this component is nested within a valid context provider."
  );
}
const bb = ae({
  inheritAttrs: !1,
  emits: ["before-show", "after-show", "before-hide", "after-hide"],
  props: {
    id: { type: [Number, String, Symbol], required: !0 },
    showDelay: { type: Number, default: 0 },
    hideDelay: { type: Number, default: 110 },
    boundarySelector: { type: String }
  },
  setup(e, { emit: t }) {
    let r;
    const n = G();
    let a = null, s = null;
    const o = tn({
      isVisible: !1,
      target: null,
      data: null,
      transition: "slide-fade",
      placement: "bottom",
      direction: "",
      positionFixed: !1,
      modifiers: [],
      isInteractive: !0,
      visibility: "click",
      isHovered: !1,
      isFocused: !1,
      autoHide: !1,
      force: !1
    });
    function i(w) {
      w && (o.direction = w.split("-")[0]);
    }
    function u({ placement: w, options: H }) {
      i(w || (H == null ? void 0 : H.placement));
    }
    const c = m(() => ({
      placement: o.placement,
      strategy: o.positionFixed ? "fixed" : "absolute",
      boundary: "",
      modifiers: [
        {
          name: "onUpdate",
          enabled: !0,
          phase: "afterWrite",
          fn: u
        },
        ...o.modifiers || []
      ],
      onFirstUpdate: u
    })), d = m(() => {
      const w = o.direction === "left" || o.direction === "right";
      let H = "";
      if (o.placement) {
        const T = o.placement.split("-");
        T.length > 1 && (H = T[1]);
      }
      return ["start", "top", "left"].includes(H) ? w ? "top" : "left" : ["end", "bottom", "right"].includes(H) ? w ? "bottom" : "right" : w ? "middle" : "center";
    });
    function f() {
      s && (s.destroy(), s = null);
    }
    function v() {
      At(() => {
        const w = cr(o.target);
        !w || !n.value || (s && s.state.elements.reference !== w && f(), s ? s.update() : s = vo(
          w,
          n.value,
          c.value
        ));
      });
    }
    function h(w) {
      Object.assign(o, Ms(w, "force"));
    }
    function b(w, H) {
      clearTimeout(r), w > 0 ? r = setTimeout(H, w) : H();
    }
    function Y(w) {
      return !w || !s ? !1 : cr(w) === s.state.elements.reference;
    }
    async function M(w = {}) {
      o.force || (w.force && (o.force = !0), b(w.showDelay ?? e.showDelay, () => {
        o.isVisible && (o.force = !1), h({
          ...w,
          isVisible: !0
        }), v();
      }));
    }
    function D(w = {}) {
      s && (w.target && !Y(w.target) || o.force || (w.force && (o.force = !0), b(w.hideDelay ?? e.hideDelay, () => {
        o.isVisible || (o.force = !1), o.isVisible = !1;
      })));
    }
    function N(w = {}) {
      w.target != null && (o.isVisible && Y(w.target) ? D(w) : M(w));
    }
    function B(w) {
      if (!s)
        return;
      const H = s.state.elements.reference;
      if (!n.value || !H)
        return;
      const T = w.target;
      ar(n.value, T) || ar(H, T) || D({ force: !0 });
    }
    function A(w) {
      (w.key === "Esc" || w.key === "Escape") && D();
    }
    function I({ detail: w }) {
      !w.id || w.id !== e.id || M(w);
    }
    function q({ detail: w }) {
      !w.id || w.id !== e.id || D(w);
    }
    function E({ detail: w }) {
      !w.id || w.id !== e.id || N(w);
    }
    function L() {
      ze(document, "keydown", A), ze(document, "click", B), ze(document, "show-popover", I), ze(document, "hide-popover", q), ze(document, "toggle-popover", E);
    }
    function X() {
      Be(document, "keydown", A), Be(document, "click", B), Be(document, "show-popover", I), Be(document, "hide-popover", q), Be(document, "toggle-popover", E);
    }
    function re(w) {
      t("before-show", w);
    }
    function J(w) {
      o.force = !1, t("after-show", w);
    }
    function C(w) {
      t("before-hide", w);
    }
    function R(w) {
      o.force = !1, f(), t("after-hide", w);
    }
    function K(w) {
      w.stopPropagation();
    }
    function O() {
      o.isHovered = !0, o.isInteractive && ["hover", "hover-focus"].includes(o.visibility) && M();
    }
    function te() {
      if (o.isHovered = !1, !s)
        return;
      const w = s.state.elements.reference;
      o.autoHide && !o.isFocused && (!w || w !== document.activeElement) && ["hover", "hover-focus"].includes(o.visibility) && D();
    }
    function le() {
      o.isFocused = !0, o.isInteractive && ["focus", "hover-focus"].includes(o.visibility) && M();
    }
    function ye(w) {
      ["focus", "hover-focus"].includes(o.visibility) && (!w.relatedTarget || !ar(n.value, w.relatedTarget)) && (o.isFocused = !1, !o.isHovered && o.autoHide && D());
    }
    function se() {
      a != null && (a.disconnect(), a = null);
    }
    return fe(
      () => n.value,
      (w) => {
        se(), w && (a = new ResizeObserver(() => {
          s && s.update();
        }), a.observe(w));
      }
    ), fe(() => o.placement, i, {
      immediate: !0
    }), gr(() => {
      L();
    }), Qr(() => {
      f(), se(), X();
    }), {
      ...uo(o),
      popoverRef: n,
      alignment: d,
      hide: D,
      setupPopper: v,
      beforeEnter: re,
      afterEnter: J,
      beforeLeave: C,
      afterLeave: R,
      onClick: K,
      onMouseOver: O,
      onMouseLeave: te,
      onFocusIn: le,
      onFocusOut: ye
    };
  }
}), Ve = (e, t) => {
  const r = e.__vccOpts || e;
  for (const [n, a] of t)
    r[n] = a;
  return r;
};
function Db(e, t, r, n, a, s) {
  return _(), P("div", {
    class: Z(["vc-popover-content-wrapper", { "is-interactive": e.isInteractive }]),
    ref: "popoverRef",
    onClick: t[0] || (t[0] = (...o) => e.onClick && e.onClick(...o)),
    onMouseover: t[1] || (t[1] = (...o) => e.onMouseOver && e.onMouseOver(...o)),
    onMouseleave: t[2] || (t[2] = (...o) => e.onMouseLeave && e.onMouseLeave(...o)),
    onFocusin: t[3] || (t[3] = (...o) => e.onFocusIn && e.onFocusIn(...o)),
    onFocusout: t[4] || (t[4] = (...o) => e.onFocusOut && e.onFocusOut(...o))
  }, [
    x(xa, {
      name: `vc-${e.transition}`,
      appear: "",
      onBeforeEnter: e.beforeEnter,
      onAfterEnter: e.afterEnter,
      onBeforeLeave: e.beforeLeave,
      onAfterLeave: e.afterLeave
    }, {
      default: ee(() => [
        e.isVisible ? (_(), P("div", dt({
          key: 0,
          tabindex: "-1",
          class: `vc-popover-content direction-${e.direction}`
        }, e.$attrs), [
          Wt(e.$slots, "default", {
            direction: e.direction,
            alignment: e.alignment,
            data: e.data,
            hide: e.hide
          }, () => [
            en(me(e.data), 1)
          ]),
          F("span", {
            class: Z([
              "vc-popover-caret",
              `direction-${e.direction}`,
              `align-${e.alignment}`
            ])
          }, null, 2)
        ], 16)) : Q("", !0)
      ]),
      _: 3
    }, 8, ["name", "onBeforeEnter", "onAfterEnter", "onBeforeLeave", "onAfterLeave"])
  ], 34);
}
const Mn = /* @__PURE__ */ Ve(bb, [["render", Db]]), wb = { class: "vc-day-popover-row" }, $b = {
  key: 0,
  class: "vc-day-popover-row-indicator"
}, _b = { class: "vc-day-popover-row-label" }, Mb = /* @__PURE__ */ ae({
  __name: "PopoverRow",
  props: {
    attribute: null
  },
  setup(e) {
    const t = e, r = m(() => {
      const { content: n, highlight: a, dot: s, bar: o, popover: i } = t.attribute;
      return i && i.hideIndicator ? null : n ? {
        class: `vc-bar vc-day-popover-row-bar vc-attr vc-${n.base.color}`
      } : a ? {
        class: `vc-highlight-bg-solid vc-day-popover-row-highlight vc-attr vc-${a.base.color}`
      } : s ? {
        class: `vc-dot vc-attr vc-${s.base.color}`
      } : o ? {
        class: `vc-bar vc-day-popover-row-bar vc-attr vc-${o.base.color}`
      } : null;
    });
    return (n, a) => (_(), P("div", wb, [
      y(r) ? (_(), P("div", $b, [
        F("span", {
          class: Z(y(r).class)
        }, null, 2)
      ])) : Q("", !0),
      F("div", _b, [
        Wt(n.$slots, "default", {}, () => [
          en(me(e.attribute.popover ? e.attribute.popover.label : "No content provided"), 1)
        ])
      ])
    ]));
  }
}), kb = {
  inheritAttrs: !1
}, De = /* @__PURE__ */ ae({
  ...kb,
  __name: "CalendarSlot",
  props: {
    name: null
  },
  setup(e) {
    const r = Qs(e.name);
    return (n, a) => y(r) ? (_(), pe(Fa(y(r)), xt(dt({ key: 0 }, n.$attrs)), null, 16)) : Wt(n.$slots, "default", { key: 1 });
  }
}), Yb = { class: "vc-day-popover-container" }, Pb = {
  key: 0,
  class: "vc-day-popover-header"
}, Tb = /* @__PURE__ */ ae({
  __name: "CalendarDayPopover",
  setup(e) {
    const { dayPopoverId: t, displayMode: r, color: n, masks: a, locale: s } = tt();
    function o(u, c) {
      return s.value.formatDate(u, c);
    }
    function i(u) {
      return s.value.formatDate(u.date, a.value.dayPopover);
    }
    return (u, c) => (_(), pe(Mn, {
      id: y(t),
      class: Z([`vc-${y(n)}`, `vc-${y(r)}`])
    }, {
      default: ee(({ data: { day: d, attributes: f }, hide: v }) => [
        x(De, {
          name: "day-popover",
          day: d,
          "day-title": i(d),
          attributes: f,
          format: o,
          masks: y(a),
          hide: v
        }, {
          default: ee(() => [
            F("div", Yb, [
              y(a).dayPopover ? (_(), P("div", Pb, me(i(d)), 1)) : Q("", !0),
              (_(!0), P(ne, null, we(f, (h) => (_(), pe(Mb, {
                key: h.key,
                attribute: h
              }, null, 8, ["attribute"]))), 128))
            ])
          ]),
          _: 2
        }, 1032, ["day", "day-title", "attributes", "masks", "hide"])
      ]),
      _: 1
    }, 8, ["id", "class"]));
  }
}), Cb = {}, Ob = {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  viewBox: "0 0 24 24"
}, Sb = /* @__PURE__ */ F("polyline", { points: "9 18 15 12 9 6" }, null, -1), Ib = [
  Sb
];
function Ab(e, t) {
  return _(), P("svg", Ob, Ib);
}
const Eb = /* @__PURE__ */ Ve(Cb, [["render", Ab]]), Nb = {}, Lb = {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  viewBox: "0 0 24 24"
}, xb = /* @__PURE__ */ F("polyline", { points: "15 18 9 12 15 6" }, null, -1), Fb = [
  xb
];
function Rb(e, t) {
  return _(), P("svg", Lb, Fb);
}
const Hb = /* @__PURE__ */ Ve(Nb, [["render", Rb]]), Wb = {}, jb = {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  viewBox: "0 0 24 24"
}, Bb = /* @__PURE__ */ F("polyline", { points: "6 9 12 15 18 9" }, null, -1), zb = [
  Bb
];
function Ub(e, t) {
  return _(), P("svg", jb, zb);
}
const Vb = /* @__PURE__ */ Ve(Wb, [["render", Ub]]), Kb = {}, Gb = {
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24"
}, Zb = /* @__PURE__ */ F("path", { d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" }, null, -1), qb = [
  Zb
];
function Xb(e, t) {
  return _(), P("svg", Gb, qb);
}
const Jb = /* @__PURE__ */ Ve(Kb, [["render", Xb]]), Qb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  IconChevronDown: Vb,
  IconChevronLeft: Hb,
  IconChevronRight: Eb,
  IconClock: Jb
}, Symbol.toStringTag, { value: "Module" })), ct = /* @__PURE__ */ ae({
  __name: "BaseIcon",
  props: {
    name: { type: String, required: !0 },
    width: { type: String },
    height: { type: String },
    size: { type: String, default: "26" },
    viewBox: { type: String }
  },
  setup(e) {
    const t = e, r = m(() => t.width || t.size), n = m(() => t.height || t.size), a = m(() => Qb[`Icon${t.name}`]);
    return (s, o) => (_(), pe(Fa(y(a)), {
      width: y(r),
      height: y(n),
      class: "vc-base-icon"
    }, null, 8, ["width", "height"]));
  }
}), eD = ["disabled"], tD = {
  key: 1,
  class: "vc-title-wrapper"
}, rD = {
  type: "button",
  class: "vc-title"
}, nD = ["disabled"], to = /* @__PURE__ */ ae({
  __name: "CalendarHeader",
  props: {
    page: null,
    layout: null,
    isLg: { type: Boolean },
    isXl: { type: Boolean },
    is2xl: { type: Boolean },
    hideTitle: { type: Boolean },
    hideArrows: { type: Boolean }
  },
  setup(e) {
    const t = e, {
      navPopoverId: r,
      navVisibility: n,
      canMovePrev: a,
      movePrev: s,
      canMoveNext: o,
      moveNext: i
    } = tt(), u = m(() => {
      switch (t.page.titlePosition) {
        case "left":
          return "bottom-start";
        case "right":
          return "bottom-end";
        default:
          return "bottom";
      }
    }), c = m(() => {
      const { page: Y } = t;
      return {
        id: r.value,
        visibility: n.value,
        placement: u.value,
        modifiers: [{ name: "flip", options: { fallbackPlacements: ["bottom"] } }],
        data: { page: Y },
        isInteractive: !0
      };
    }), d = m(() => t.page.titlePosition.includes("left")), f = m(() => t.page.titlePosition.includes("right")), v = m(() => t.layout ? t.layout : d.value ? "tu-pn" : f.value ? "pn-tu" : "p-tu-n;"), h = m(() => ({
      prev: v.value.includes("p") && !t.hideArrows,
      title: v.value.includes("t") && !t.hideTitle,
      next: v.value.includes("n") && !t.hideArrows
    })), b = m(() => ({ gridTemplateColumns: v.value.split("").map((M) => {
      switch (M) {
        case "p":
          return "[prev] auto";
        case "n":
          return "[next] auto";
        case "t":
          return "[title] auto";
        case "-":
          return "1fr";
        default:
          return "";
      }
    }).join(" ") }));
    return (Y, M) => (_(), P("div", {
      class: Z(["vc-header", { "is-lg": e.isLg, "is-xl": e.isXl, "is-2xl": e.is2xl }]),
      style: Lt(y(b))
    }, [
      y(h).prev ? (_(), P("button", {
        key: 0,
        type: "button",
        class: "vc-arrow vc-prev vc-focus",
        disabled: !y(a),
        onClick: M[0] || (M[0] = //@ts-ignore
        (...D) => y(s) && y(s)(...D)),
        onKeydown: M[1] || (M[1] = Yn(
          //@ts-ignore
          (...D) => y(s) && y(s)(...D),
          ["space", "enter"]
        ))
      }, [
        x(De, {
          name: "header-prev-button",
          disabled: !y(a)
        }, {
          default: ee(() => [
            x(ct, {
              name: "ChevronLeft",
              size: "24"
            })
          ]),
          _: 1
        }, 8, ["disabled"])
      ], 40, eD)) : Q("", !0),
      y(h).title ? (_(), P("div", tD, [
        x(De, { name: "header-title-wrapper" }, {
          default: ee(() => [
            Ra((_(), P("button", rD, [
              x(De, {
                name: "header-title",
                title: e.page.title
              }, {
                default: ee(() => [
                  F("span", null, me(e.page.title), 1)
                ]),
                _: 1
              }, 8, ["title"])
            ])), [
              [y(Vs), y(c)]
            ])
          ]),
          _: 1
        })
      ])) : Q("", !0),
      y(h).next ? (_(), P("button", {
        key: 2,
        type: "button",
        class: "vc-arrow vc-next vc-focus",
        disabled: !y(o),
        onClick: M[2] || (M[2] = //@ts-ignore
        (...D) => y(i) && y(i)(...D)),
        onKeydown: M[3] || (M[3] = Yn(
          //@ts-ignore
          (...D) => y(i) && y(i)(...D),
          ["space", "enter"]
        ))
      }, [
        x(De, {
          name: "header-next-button",
          disabled: !y(o)
        }, {
          default: ee(() => [
            x(ct, {
              name: "ChevronRight",
              size: "24"
            })
          ]),
          _: 1
        }, 8, ["disabled"])
      ], 40, nD)) : Q("", !0)
    ], 6));
  }
}), ro = Symbol("__vc_page_context__");
function aD(e) {
  const { locale: t, getDateAddress: r, canMove: n } = tt();
  function a(i, u) {
    const { month: c, year: d } = r(/* @__PURE__ */ new Date());
    return js().map((f, v) => {
      const h = v + 1;
      return {
        month: h,
        year: i,
        id: Kg(h, i),
        label: t.value.formatDate(f, u),
        ariaLabel: t.value.formatDate(f, "MMMM"),
        isActive: h === e.value.month && i === e.value.year,
        isCurrent: h === c && i === d,
        isDisabled: !n(
          { month: h, year: i },
          { position: e.value.position }
        )
      };
    });
  }
  function s(i, u) {
    const { year: c } = r(/* @__PURE__ */ new Date()), { position: d } = e.value, f = [];
    for (let v = i; v <= u; v += 1) {
      const h = [...Array(12).keys()].some(
        (b) => n({ month: b + 1, year: v }, { position: d })
      );
      f.push({
        year: v,
        id: v.toString(),
        label: v.toString(),
        ariaLabel: v.toString(),
        isActive: v === e.value.year,
        isCurrent: v === c,
        isDisabled: !h
      });
    }
    return f;
  }
  const o = { page: e, getMonthItems: a, getYearItems: s };
  return jt(ro, o), o;
}
function no() {
  const e = Bt(ro);
  if (e)
    return e;
  throw new Error(
    "Page context missing. Please verify this component is nested within a valid context provider."
  );
}
const sD = { class: "vc-nav-header" }, oD = ["disabled"], iD = ["disabled"], lD = { class: "vc-nav-items" }, uD = ["data-id", "aria-label", "disabled", "onClick", "onKeydown"], cD = /* @__PURE__ */ ae({
  __name: "CalendarNav",
  setup(e) {
    const { masks: t, move: r } = tt(), { page: n, getMonthItems: a, getYearItems: s } = no(), o = G(!0), i = 12, u = G(n.value.year), c = G(v(n.value.year)), d = G(null);
    function f() {
      setTimeout(() => {
        if (d.value == null)
          return;
        const T = d.value.querySelector(
          ".vc-nav-item:not(:disabled)"
        );
        T && T.focus();
      }, 10);
    }
    function v(T) {
      return Math.floor(T / i);
    }
    function h() {
      o.value = !o.value;
    }
    function b(T) {
      return T * i;
    }
    function Y(T) {
      return i * (T + 1) - 1;
    }
    function M() {
      le.value && (o.value && N(), A());
    }
    function D() {
      ye.value && (o.value && B(), I());
    }
    function N() {
      u.value--;
    }
    function B() {
      u.value++;
    }
    function A() {
      c.value--;
    }
    function I() {
      c.value++;
    }
    const q = m(
      () => a(u.value, t.value.navMonths).map((T) => ({
        ...T,
        click: () => r(
          { month: T.month, year: T.year },
          { position: n.value.position }
        )
      }))
    ), E = m(
      () => a(u.value - 1, t.value.navMonths)
    ), L = m(
      () => E.value.some((T) => !T.isDisabled)
    ), X = m(
      () => a(u.value + 1, t.value.navMonths)
    ), re = m(
      () => X.value.some((T) => !T.isDisabled)
    ), J = m(
      () => s(
        b(c.value),
        Y(c.value)
      ).map((T) => ({
        ...T,
        click: () => {
          u.value = T.year, o.value = !0, f();
        }
      }))
    ), C = m(
      () => s(
        b(c.value - 1),
        Y(c.value - 1)
      )
    ), R = m(
      () => C.value.some((T) => !T.isDisabled)
    ), K = m(
      () => s(
        b(c.value + 1),
        Y(c.value + 1)
      )
    ), O = m(
      () => K.value.some((T) => !T.isDisabled)
    ), te = m(
      () => o.value ? q.value : J.value
    ), le = m(
      () => o.value ? L.value : R.value
    ), ye = m(
      () => o.value ? re.value : O.value
    ), se = m(() => $s(J.value.map((T) => T.year))), w = m(() => ot(J.value.map((T) => T.year))), H = m(() => o.value ? u.value : `${se.value} - ${w.value}`);
    return Ha(() => {
      u.value = n.value.year, f();
    }), fe(
      () => u.value,
      (T) => c.value = v(T)
    ), gr(() => f()), (T, ue) => (_(), P("div", {
      class: "vc-nav-container",
      ref_key: "navContainer",
      ref: d
    }, [
      F("div", sD, [
        F("button", {
          type: "button",
          class: "vc-nav-arrow is-left vc-focus",
          disabled: !y(le),
          onClick: M,
          onKeydown: ue[0] || (ue[0] = (U) => y(rr)(U, M))
        }, [
          x(De, {
            name: "nav-prev-button",
            move: M,
            disabled: !y(le)
          }, {
            default: ee(() => [
              x(ct, {
                name: "ChevronLeft",
                width: "22px",
                height: "24px"
              })
            ]),
            _: 1
          }, 8, ["disabled"])
        ], 40, oD),
        F("button", {
          type: "button",
          class: "vc-nav-title vc-focus",
          onClick: h,
          onKeydown: ue[1] || (ue[1] = (U) => y(rr)(U, h))
        }, me(y(H)), 33),
        F("button", {
          type: "button",
          class: "vc-nav-arrow is-right vc-focus",
          disabled: !y(ye),
          onClick: D,
          onKeydown: ue[2] || (ue[2] = (U) => y(rr)(U, D))
        }, [
          x(De, {
            name: "nav-next-button",
            move: D,
            disabled: !y(ye)
          }, {
            default: ee(() => [
              x(ct, {
                name: "ChevronRight",
                width: "22px",
                height: "24px"
              })
            ]),
            _: 1
          }, 8, ["disabled"])
        ], 40, iD)
      ]),
      F("div", lD, [
        (_(!0), P(ne, null, we(y(te), (U) => (_(), P("button", {
          key: U.label,
          type: "button",
          "data-id": U.id,
          "aria-label": U.ariaLabel,
          class: Z(["vc-nav-item vc-focus", [
            U.isActive ? "is-active" : U.isCurrent ? "is-current" : ""
          ]]),
          disabled: U.isDisabled,
          onClick: U.click,
          onKeydown: (_e) => y(rr)(_e, U.click)
        }, me(U.label), 43, uD))), 128))
      ])
    ], 512));
  }
}), ao = /* @__PURE__ */ ae({
  __name: "CalendarPageProvider",
  props: {
    page: null
  },
  setup(e) {
    return aD(nr(e, "page")), (r, n) => Wt(r.$slots, "default");
  }
}), dD = /* @__PURE__ */ ae({
  __name: "CalendarNavPopover",
  setup(e) {
    const { navPopoverId: t, color: r, displayMode: n } = tt();
    return (a, s) => (_(), pe(Mn, {
      id: y(t),
      class: Z(["vc-nav-popover-container", `vc-${y(r)}`, `vc-${y(n)}`])
    }, {
      default: ee(({ data: o }) => [
        x(ao, {
          page: o.page
        }, {
          default: ee(() => [
            x(De, { name: "nav" }, {
              default: ee(() => [
                x(cD)
              ]),
              _: 1
            })
          ]),
          _: 2
        }, 1032, ["page"])
      ]),
      _: 1
    }, 8, ["id", "class"]));
  }
}), fD = ae({
  directives: { popover: Vs },
  components: { CalendarSlot: De },
  props: {
    day: { type: Object, required: !0 }
  },
  setup(e) {
    const {
      locale: t,
      theme: r,
      attributeContext: n,
      dayPopoverId: a,
      onDayClick: s,
      onDayMouseenter: o,
      onDayMouseleave: i,
      onDayFocusin: u,
      onDayFocusout: c,
      onDayKeydown: d
    } = tt(), f = m(() => e.day), v = m(() => n.value.getCells(f.value)), h = m(
      () => v.value.map((O) => O.data)
    ), b = m(() => ({
      ...f.value,
      attributes: h.value,
      attributeCells: v.value
    }));
    function Y({ data: O }, { popovers: te }) {
      const { key: le, customData: ye, popover: se } = O;
      if (!se)
        return;
      const w = ia(
        {
          key: le,
          customData: ye,
          attribute: O
        },
        { ...se },
        {
          visibility: se.label ? "hover" : "click",
          placement: "bottom",
          isInteractive: !se.label
        }
      );
      te.splice(0, 0, w);
    }
    const M = m(() => {
      const O = {
        ...r.value.prepareRender({}),
        popovers: []
      };
      return v.value.forEach((te) => {
        r.value.render(te, O), Y(te, O);
      }), O;
    }), D = m(() => M.value.highlights), N = m(() => !!xe(D.value)), B = m(() => M.value.content), A = m(() => M.value.dots), I = m(() => !!xe(A.value)), q = m(() => M.value.bars), E = m(() => !!xe(q.value)), L = m(() => M.value.popovers), X = m(
      () => L.value.map((O) => O.attribute)
    ), re = Qs("day-content"), J = m(() => [
      "vc-day",
      ...f.value.classes,
      { "vc-day-box-center-center": !re },
      { "is-not-in-month": !e.day.inMonth }
    ]), C = m(() => {
      let O;
      f.value.isFocusable ? O = "0" : O = "-1";
      const te = [
        "vc-day-content vc-focusable vc-focus vc-attr",
        { "vc-disabled": f.value.isDisabled },
        Xe(ot(D.value), "contentClass"),
        Xe(ot(B.value), "class") || ""
      ], le = {
        ...Xe(ot(D.value), "contentStyle"),
        ...Xe(ot(B.value), "style")
      };
      return {
        class: te,
        style: le,
        tabindex: O,
        "aria-label": f.value.ariaLabel,
        "aria-disabled": !!f.value.isDisabled,
        role: "button"
      };
    }), R = m(() => ({
      click(O) {
        s(b.value, O);
      },
      mouseenter(O) {
        o(b.value, O);
      },
      mouseleave(O) {
        i(b.value, O);
      },
      focusin(O) {
        u(b.value, O);
      },
      focusout(O) {
        c(b.value, O);
      },
      keydown(O) {
        d(b.value, O);
      }
    })), K = m(() => xe(L.value) ? ia(
      {
        id: a.value,
        data: { day: f, attributes: X.value }
      },
      ...L.value
    ) : null);
    return {
      attributes: h,
      attributeCells: v,
      bars: q,
      dayClasses: J,
      dayContentProps: C,
      dayContentEvents: R,
      dayPopover: K,
      glyphs: M,
      dots: A,
      hasDots: I,
      hasBars: E,
      highlights: D,
      hasHighlights: N,
      locale: t,
      popovers: L
    };
  }
}), vD = {
  key: 0,
  class: "vc-highlights vc-day-layer"
}, hD = {
  key: 1,
  class: "vc-day-layer vc-day-box-center-bottom"
}, mD = { class: "vc-dots" }, pD = {
  key: 2,
  class: "vc-day-layer vc-day-box-center-bottom"
}, yD = { class: "vc-bars" };
function gD(e, t, r, n, a, s) {
  const o = Le("CalendarSlot"), i = co("popover");
  return _(), P("div", {
    class: Z(e.dayClasses)
  }, [
    e.hasHighlights ? (_(), P("div", vD, [
      (_(!0), P(ne, null, we(e.highlights, ({ key: u, wrapperClass: c, class: d, style: f }) => (_(), P("div", {
        key: u,
        class: Z(c)
      }, [
        F("div", {
          class: Z(d),
          style: Lt(f)
        }, null, 6)
      ], 2))), 128))
    ])) : Q("", !0),
    x(o, {
      name: "day-content",
      day: e.day,
      attributes: e.attributes,
      "attribute-cells": e.attributeCells,
      dayProps: e.dayContentProps,
      dayEvents: e.dayContentEvents,
      locale: e.locale
    }, {
      default: ee(() => [
        Ra((_(), P("div", dt(e.dayContentProps, fo(e.dayContentEvents, !0)), [
          en(me(e.day.label), 1)
        ], 16)), [
          [i, e.dayPopover]
        ])
      ]),
      _: 1
    }, 8, ["day", "attributes", "attribute-cells", "dayProps", "dayEvents", "locale"]),
    e.hasDots ? (_(), P("div", hD, [
      F("div", mD, [
        (_(!0), P(ne, null, we(e.dots, ({ key: u, class: c, style: d }) => (_(), P("span", {
          key: u,
          class: Z(c),
          style: Lt(d)
        }, null, 6))), 128))
      ])
    ])) : Q("", !0),
    e.hasBars ? (_(), P("div", pD, [
      F("div", yD, [
        (_(!0), P(ne, null, we(e.bars, ({ key: u, class: c, style: d }) => (_(), P("span", {
          key: u,
          class: Z(c),
          style: Lt(d)
        }, null, 6))), 128))
      ])
    ])) : Q("", !0)
  ], 2);
}
const bD = /* @__PURE__ */ Ve(fD, [["render", gD]]), DD = { class: "vc-weekdays" }, wD = ["onClick"], $D = {
  inheritAttrs: !1
}, _D = /* @__PURE__ */ ae({
  ...$D,
  __name: "CalendarPage",
  setup(e) {
    const { page: t } = no(), { onWeeknumberClick: r } = tt();
    return (n, a) => (_(), P("div", {
      class: Z([
        "vc-pane",
        `row-${y(t).row}`,
        `row-from-end-${y(t).rowFromEnd}`,
        `column-${y(t).column}`,
        `column-from-end-${y(t).columnFromEnd}`
      ]),
      ref: "pane"
    }, [
      x(to, {
        page: y(t),
        "is-lg": "",
        "hide-arrows": ""
      }, null, 8, ["page"]),
      F("div", {
        class: Z(["vc-weeks", {
          [`vc-show-weeknumbers-${y(t).weeknumberPosition}`]: y(t).weeknumberPosition
        }])
      }, [
        F("div", DD, [
          (_(!0), P(ne, null, we(y(t).weekdays, ({ weekday: s, label: o }, i) => (_(), P("div", {
            key: i,
            class: Z(`vc-weekday vc-weekday-${s}`)
          }, me(o), 3))), 128))
        ]),
        (_(!0), P(ne, null, we(y(t).viewWeeks, (s) => (_(), P("div", {
          key: `weeknumber-${s.weeknumber}`,
          class: "vc-week"
        }, [
          y(t).weeknumberPosition ? (_(), P("div", {
            key: 0,
            class: Z(["vc-weeknumber", `is-${y(t).weeknumberPosition}`])
          }, [
            F("span", {
              class: Z(["vc-weeknumber-content"]),
              onClick: (o) => y(r)(s, o)
            }, me(s.weeknumberDisplay), 9, wD)
          ], 2)) : Q("", !0),
          (_(!0), P(ne, null, we(s.days, (o) => (_(), pe(bD, {
            key: o.id,
            day: o
          }, null, 8, ["day"]))), 128))
        ]))), 128))
      ], 2)
    ], 2));
  }
}), MD = ae({
  components: {
    CalendarHeader: to,
    CalendarPage: _D,
    CalendarNavPopover: dD,
    CalendarDayPopover: Tb,
    CalendarPageProvider: ao,
    CalendarSlot: De
  },
  props: pb,
  emit: yb,
  setup(e, { emit: t, slots: r }) {
    return gb(e, { emit: t, slots: r });
  }
}), kD = { class: "vc-pane-header-wrapper" };
function YD(e, t, r, n, a, s) {
  const o = Le("CalendarHeader"), i = Le("CalendarPage"), u = Le("CalendarSlot"), c = Le("CalendarPageProvider"), d = Le("CalendarDayPopover"), f = Le("CalendarNavPopover");
  return _(), P(ne, null, [
    F("div", dt({ "data-helptext": "Press the arrow keys to navigate by day, Home and End to navigate to week ends, PageUp and PageDown to navigate by month, Alt+PageUp and Alt+PageDown to navigate by year" }, e.$attrs, {
      class: [
        "vc-container",
        `vc-${e.view}`,
        `vc-${e.color}`,
        `vc-${e.displayMode}`,
        {
          "vc-expanded": e.expanded,
          "vc-bordered": !e.borderless,
          "vc-transparent": e.transparent
        }
      ],
      onMouseup: t[0] || (t[0] = lo(() => {
      }, ["prevent"])),
      ref: "containerRef"
    }), [
      F("div", {
        class: Z(["vc-pane-container", { "in-transition": e.inTransition }])
      }, [
        F("div", kD, [
          e.firstPage ? (_(), pe(o, {
            key: 0,
            page: e.firstPage,
            "is-lg": "",
            "hide-title": ""
          }, null, 8, ["page"])) : Q("", !0)
        ]),
        x(xa, {
          name: `vc-${e.transitionName}`,
          onBeforeEnter: e.onTransitionBeforeEnter,
          onAfterEnter: e.onTransitionAfterEnter
        }, {
          default: ee(() => [
            (_(), P("div", {
              key: e.pages[0].id,
              class: "vc-pane-layout",
              style: Lt({
                gridTemplateColumns: `repeat(${e.columns}, 1fr)`
              })
            }, [
              (_(!0), P(ne, null, we(e.pages, (v) => (_(), pe(c, {
                key: v.id,
                page: v
              }, {
                default: ee(() => [
                  x(u, {
                    name: "page",
                    page: v
                  }, {
                    default: ee(() => [
                      x(i)
                    ]),
                    _: 2
                  }, 1032, ["page"])
                ]),
                _: 2
              }, 1032, ["page"]))), 128))
            ], 4))
          ]),
          _: 1
        }, 8, ["name", "onBeforeEnter", "onAfterEnter"]),
        x(u, { name: "footer" })
      ], 2)
    ], 16),
    x(d),
    x(f)
  ], 64);
}
const PD = /* @__PURE__ */ Ve(MD, [["render", YD]]), so = Symbol("__vc_date_picker_context__"), TD = {
  ...Zs,
  mode: { type: String, default: "date" },
  modelValue: {
    type: [Number, String, Date, Object]
  },
  modelModifiers: {
    type: Object,
    default: () => ({})
  },
  rules: [String, Object],
  is24hr: Boolean,
  hideTimeHeader: Boolean,
  timeAccuracy: { type: Number, default: 2 },
  isRequired: Boolean,
  isRange: Boolean,
  updateOnInput: {
    type: Boolean,
    default: () => Ue("datePicker.updateOnInput")
  },
  inputDebounce: {
    type: Number,
    default: () => Ue("datePicker.inputDebounce")
  },
  popover: {
    type: [Boolean, Object],
    default: !0
  },
  dragAttribute: Object,
  selectAttribute: Object,
  attributes: [Object, Array]
}, CD = [
  "update:modelValue",
  "drag",
  "dayclick",
  "daykeydown",
  "popover-will-show",
  "popover-did-show",
  "popover-will-hide",
  "popover-did-hide"
];
function OD(e, { emit: t, slots: r }) {
  Js(r, { footer: "dp-footer" });
  const n = qs(e), { locale: a, masks: s, disabledAttribute: o } = n, i = G(!1), u = G(Symbol()), c = G(null), d = G(null), f = G(["", ""]), v = G(null), h = G(null);
  let b, Y, M = !0;
  const D = m(() => e.isRange || e.modelModifiers.range === !0), N = m(
    () => D.value && c.value != null ? c.value.start : null
  ), B = m(
    () => D.value && c.value != null ? c.value.end : null
  ), A = m(() => e.mode.toLowerCase() === "date"), I = m(
    () => e.mode.toLowerCase() === "datetime"
  ), q = m(() => e.mode.toLowerCase() === "time"), E = m(() => !!d.value), L = m(() => {
    let l = "date";
    e.modelModifiers.number && (l = "number"), e.modelModifiers.string && (l = "string");
    const p = s.value.modelValue || "iso";
    return ue({ type: l, mask: p });
  }), X = m(
    () => wt(d.value ?? c.value)
  ), re = m(() => q.value ? e.is24hr ? s.value.inputTime24hr : s.value.inputTime : I.value ? e.is24hr ? s.value.inputDateTime24hr : s.value.inputDateTime : s.value.input), J = m(() => /[Hh]/g.test(re.value)), C = m(
    () => /[dD]{1,2}|Do|W{1,4}|M{1,4}|YY(?:YY)?/g.test(re.value)
  ), R = m(() => {
    if (J.value && C.value)
      return "dateTime";
    if (C.value)
      return "date";
    if (J.value)
      return "time";
  }), K = m(() => {
    var l;
    const p = ((l = v.value) == null ? void 0 : l.$el.previousElementSibling) ?? void 0;
    return Rt({}, e.popover, Ue("datePicker.popover"), {
      target: p
    });
  }), O = m(
    () => Us({
      ...K.value,
      id: u.value
    })
  ), te = m(() => D.value ? {
    start: f.value[0],
    end: f.value[1]
  } : f.value[0]), le = m(() => {
    const l = ["start", "end"].map((p) => ({
      input: Ze(p),
      change: Vt(p),
      keyup: Dt,
      ...e.popover && O.value
    }));
    return D.value ? {
      start: l[0],
      end: l[1]
    } : l[0];
  }), ye = m(() => {
    if (!ce(c.value))
      return null;
    const l = {
      key: "select-drag",
      ...e.selectAttribute,
      dates: c.value,
      pinPage: !0
    }, { dot: p, bar: $, highlight: S, content: V } = l;
    return !p && !$ && !S && !V && (l.highlight = !0), l;
  }), se = m(() => {
    if (!D.value || !ce(d.value))
      return null;
    const l = {
      key: "select-drag",
      ...e.dragAttribute,
      dates: d.value
    }, { dot: p, bar: $, highlight: S, content: V } = l;
    return !p && !$ && !S && !V && (l.highlight = {
      startEnd: {
        fillMode: "outline"
      }
    }), l;
  }), w = m(() => {
    const l = $e(e.attributes) ? [...e.attributes] : [];
    return se.value ? l.unshift(se.value) : ye.value && l.unshift(ye.value), l;
  }), H = m(() => ue(
    e.rules === "auto" ? T() : e.rules ?? {}
  ));
  function T() {
    const l = {
      ms: [0, 999],
      sec: [0, 59],
      min: [0, 59],
      hr: [0, 23]
    }, p = A.value ? 0 : e.timeAccuracy;
    return [0, 1].map(($) => {
      switch (p) {
        case 0:
          return {
            hours: l.hr[$],
            minutes: l.min[$],
            seconds: l.sec[$],
            milliseconds: l.ms[$]
          };
        case 1:
          return {
            minutes: l.min[$],
            seconds: l.sec[$],
            milliseconds: l.ms[$]
          };
        case 3:
          return { milliseconds: l.ms[$] };
        case 4:
          return {};
        default:
          return { seconds: l.sec[$], milliseconds: l.ms[$] };
      }
    });
  }
  function ue(l) {
    return $e(l) ? l.length === 1 ? [l[0], l[0]] : l : [l, l];
  }
  function U(l) {
    return ue(l).map(
      (p, $) => ({
        ...p,
        rules: H.value[$]
      })
    );
  }
  function _e(l) {
    return l == null ? !1 : ke(l) ? !isNaN(l) : it(l) ? !isNaN(l.getTime()) : Ce(l) ? l !== "" : Dn(l);
  }
  function Me(l) {
    return Fe(l) && "start" in l && "end" in l && _e(l.start ?? null) && _e(l.end ?? null);
  }
  function ce(l) {
    return Me(l) || _e(l);
  }
  function Ae(l, p) {
    if (l == null && p == null)
      return !0;
    if (l == null || p == null)
      return !1;
    const $ = it(l), S = it(p);
    return $ && S ? l.getTime() === p.getTime() : $ || S ? !1 : Ae(l.start, p.start) && Ae(l.end, p.end);
  }
  function Ee(l) {
    return !ce(l) || !o.value ? !1 : o.value.intersectsRange(a.value.range(l));
  }
  function Ke(l, p, $, S) {
    if (!ce(l))
      return null;
    if (Me(l)) {
      const V = a.value.toDate(l.start, {
        ...p[0],
        fillDate: N.value ?? void 0,
        patch: $
      }), de = a.value.toDate(l.end, {
        ...p[1],
        fillDate: B.value ?? void 0,
        patch: $
      });
      return Zt({ start: V, end: de }, S);
    }
    return a.value.toDateOrNull(l, {
      ...p[0],
      fillDate: c.value,
      patch: $
    });
  }
  function Ge(l, p) {
    return Me(l) ? {
      start: a.value.fromDate(l.start, p[0]),
      end: a.value.fromDate(l.end, p[1])
    } : D.value ? null : a.value.fromDate(l, p[0]);
  }
  function Te(l, p = {}) {
    return clearTimeout(b), new Promise(($) => {
      const { debounce: S = 0, ...V } = p;
      S > 0 ? b = window.setTimeout(() => {
        $(Ne(l, V));
      }, S) : $(Ne(l, V));
    });
  }
  function Ne(l, {
    config: p = L.value,
    patch: $ = "dateTime",
    clearIfEqual: S = !1,
    formatInput: V = !0,
    hidePopover: de = !1,
    dragging: be = E.value,
    targetPriority: nt,
    moveToValue: at = !1
  } = {}) {
    const Ir = U(p);
    let ge = Ke(
      l,
      Ir,
      $,
      nt
    );
    if (Ee(ge)) {
      if (be)
        return null;
      ge = c.value, de = !1;
    } else ge == null && e.isRequired ? ge = c.value : (
      // Clear value if same value was passed
      ge != null && Ae(c.value, ge) && S && (ge = null)
    );
    const Qt = be ? d : c, Pt = !Ae(Qt.value, ge);
    Qt.value = ge, be || (d.value = null);
    const Tt = Ge(
      ge,
      L.value
    );
    return Pt && (M = !1, t(be ? "drag" : "update:modelValue", Tt), At(() => M = !0)), de && !be && Yt(), V && rt(), at && At(() => Xt(nt ?? "start")), Tt;
  }
  function rt() {
    At(() => {
      const l = U({
        type: "string",
        mask: re.value
      }), p = Ge(
        d.value ?? c.value,
        l
      );
      D.value ? f.value = [p && p.start, p && p.end] : f.value = [p, ""];
    });
  }
  function Ut(l, p, $) {
    f.value.splice(p === "start" ? 0 : 1, 1, l);
    const S = D.value ? {
      start: f.value[0],
      end: f.value[1] || f.value[0]
    } : l, V = {
      type: "string",
      mask: re.value
    };
    Te(S, {
      ...$,
      config: V,
      patch: R.value,
      targetPriority: p,
      moveToValue: !0
    });
  }
  function Ze(l) {
    return (p) => {
      e.updateOnInput && Ut(p.currentTarget.value, l, {
        formatInput: !1,
        hidePopover: !1,
        debounce: e.inputDebounce
      });
    };
  }
  function Vt(l) {
    return (p) => {
      Ut(p.currentTarget.value, l, {
        formatInput: !0,
        hidePopover: !1
      });
    };
  }
  function Dt(l) {
    l.key === "Escape" && Te(c.value, {
      formatInput: !0,
      hidePopover: !0
    });
  }
  function wt(l) {
    return D.value ? [
      l && l.start ? a.value.getDateParts(l.start) : null,
      l && l.end ? a.value.getDateParts(l.end) : null
    ] : [l ? a.value.getDateParts(l) : null];
  }
  function Yr() {
    d.value = null, rt();
  }
  function Pr(l) {
    t("popover-will-show", l);
  }
  function $t(l) {
    t("popover-did-show", l);
  }
  function _t(l) {
    Yr(), t("popover-will-hide", l);
  }
  function Kt(l) {
    t("popover-did-hide", l);
  }
  function Mt(l) {
    const p = {
      patch: "date",
      formatInput: !0,
      hidePopover: !0
    };
    if (D.value) {
      const $ = !E.value;
      $ ? Y = { start: l.startDate, end: l.endDate } : Y != null && (Y.end = l.date), Te(Y, {
        ...p,
        dragging: $
      });
    } else
      Te(l.date, {
        ...p,
        clearIfEqual: !e.isRequired
      });
  }
  function kt(l, p) {
    Mt(l), t("dayclick", l, p);
  }
  function Gt(l, p) {
    switch (p.key) {
      case " ":
      case "Enter": {
        Mt(l), p.preventDefault();
        break;
      }
      case "Escape":
        Yt();
    }
    t("daykeydown", l, p);
  }
  function Tr(l, p) {
    !E.value || Y == null || (Y.end = l.date, Te(Zt(Y), {
      patch: "date",
      formatInput: !0
    }));
  }
  function Cr(l = {}) {
    Jr({
      ...K.value,
      ...l,
      isInteractive: !0,
      id: u.value
    });
  }
  function Yt(l = {}) {
    Ht({
      hideDelay: 10,
      force: !0,
      ...K.value,
      ...l,
      id: u.value
    });
  }
  function Or(l) {
    zs({
      ...K.value,
      ...l,
      isInteractive: !0,
      id: u.value
    });
  }
  function Zt(l, p) {
    const { start: $, end: S } = l;
    if ($ > S)
      switch (p) {
        case "start":
          return { start: $, end: $ };
        case "end":
          return { start: S, end: S };
        default:
          return { start: S, end: $ };
      }
    return { start: $, end: S };
  }
  async function qt(l, p = {}) {
    return h.value == null ? !1 : h.value.move(l, p);
  }
  async function Sr(l, p = {}) {
    return h.value == null ? !1 : h.value.moveBy(l, p);
  }
  async function Xt(l, p = {}) {
    const $ = c.value;
    if (h.value == null || !ce($))
      return !1;
    const S = l !== "end", V = S ? 1 : -1, de = Me($) ? S ? $.start : $.end : $, be = Ts(de, "monthly", a.value);
    return h.value.move(be, { position: V, ...p });
  }
  fe(
    () => e.isRange,
    (l) => {
      l && console.warn(
        "The `is-range` prop will be deprecated in future releases. Please use the `range` modifier."
      );
    },
    { immediate: !0 }
  ), fe(
    () => D.value,
    () => {
      Ne(null, { formatInput: !0 });
    }
  ), fe(
    () => re.value,
    () => rt()
  ), fe(
    () => e.modelValue,
    (l) => {
      M && Ne(l, {
        formatInput: !0,
        hidePopover: !1
      });
    }
  ), fe(
    () => H.value,
    () => {
      Fe(e.rules) && Ne(e.modelValue, {
        formatInput: !0,
        hidePopover: !1
      });
    }
  ), fe(
    () => e.timezone,
    () => {
      Ne(c.value, { formatInput: !0 });
    }
  );
  const Jt = ue(L.value);
  c.value = Ke(
    e.modelValue ?? null,
    Jt,
    "dateTime"
  ), gr(() => {
    Ne(e.modelValue, {
      formatInput: !0,
      hidePopover: !1
    });
  }), At(() => i.value = !0);
  const g = {
    ...n,
    showCalendar: i,
    datePickerPopoverId: u,
    popoverRef: v,
    popoverEvents: O,
    calendarRef: h,
    isRange: D,
    isTimeMode: q,
    isDateTimeMode: I,
    is24hr: nr(e, "is24hr"),
    hideTimeHeader: nr(e, "hideTimeHeader"),
    timeAccuracy: nr(e, "timeAccuracy"),
    isDragging: E,
    inputValue: te,
    inputEvents: le,
    dateParts: X,
    attributes: w,
    rules: H,
    move: qt,
    moveBy: Sr,
    moveToValue: Xt,
    updateValue: Te,
    showPopover: Cr,
    hidePopover: Yt,
    togglePopover: Or,
    onDayClick: kt,
    onDayKeydown: Gt,
    onDayMouseEnter: Tr,
    onPopoverBeforeShow: Pr,
    onPopoverAfterShow: $t,
    onPopoverBeforeHide: _t,
    onPopoverAfterHide: Kt
  };
  return jt(so, g), g;
}
function kn() {
  const e = Bt(so);
  if (e)
    return e;
  throw new Error(
    "DatePicker context missing. Please verify this component is nested within a valid context provider."
  );
}
const SD = [
  { value: 0, label: "12" },
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
  { value: 5, label: "5" },
  { value: 6, label: "6" },
  { value: 7, label: "7" },
  { value: 8, label: "8" },
  { value: 9, label: "9" },
  { value: 10, label: "10" },
  { value: 11, label: "11" }
], ID = [
  { value: 12, label: "12" },
  { value: 13, label: "1" },
  { value: 14, label: "2" },
  { value: 15, label: "3" },
  { value: 16, label: "4" },
  { value: 17, label: "5" },
  { value: 18, label: "6" },
  { value: 19, label: "7" },
  { value: 20, label: "8" },
  { value: 21, label: "9" },
  { value: 22, label: "10" },
  { value: 23, label: "11" }
];
function AD(e) {
  const t = kn(), {
    locale: r,
    isRange: n,
    isTimeMode: a,
    dateParts: s,
    rules: o,
    is24hr: i,
    hideTimeHeader: u,
    timeAccuracy: c,
    updateValue: d
  } = t;
  function f(C) {
    C = Object.assign(h.value, C);
    let R = null;
    if (n.value) {
      const K = v.value ? C : s.value[0], O = v.value ? s.value[1] : C;
      R = { start: K, end: O };
    } else
      R = C;
    d(R, {
      patch: "time",
      targetPriority: v.value ? "start" : "end",
      moveToValue: !0
    });
  }
  const v = m(() => e.position === 0), h = m(
    () => s.value[e.position] || { isValid: !1 }
  ), b = m(() => Dn(h.value)), Y = m(() => !!h.value.isValid), M = m(() => !u.value && Y.value), D = m(() => {
    if (!b.value)
      return null;
    let C = r.value.toDate(h.value);
    return h.value.hours === 24 && (C = new Date(C.getTime() - 1)), C;
  }), N = m({
    get() {
      return h.value.hours;
    },
    set(C) {
      f({ hours: C });
    }
  }), B = m({
    get() {
      return h.value.minutes;
    },
    set(C) {
      f({ minutes: C });
    }
  }), A = m({
    get() {
      return h.value.seconds;
    },
    set(C) {
      f({ seconds: C });
    }
  }), I = m({
    get() {
      return h.value.milliseconds;
    },
    set(C) {
      f({ milliseconds: C });
    }
  }), q = m({
    get() {
      return h.value.hours < 12;
    },
    set(C) {
      C = String(C).toLowerCase() == "true";
      let R = N.value;
      C && R >= 12 ? R -= 12 : !C && R < 12 && (R += 12), f({ hours: R });
    }
  }), E = m(
    () => X1(h.value, o.value[e.position])
  ), L = m(() => SD.filter(
    (C) => E.value.hours.some((R) => R.value === C.value)
  )), X = m(() => ID.filter(
    (C) => E.value.hours.some((R) => R.value === C.value)
  )), re = m(() => i.value ? E.value.hours : q.value ? L.value : X.value), J = m(() => {
    const C = [];
    return xe(L.value) && C.push({ value: !0, label: "AM" }), xe(X.value) && C.push({ value: !1, label: "PM" }), C;
  });
  return {
    ...t,
    showHeader: M,
    timeAccuracy: c,
    parts: h,
    isValid: Y,
    date: D,
    hours: N,
    minutes: B,
    seconds: A,
    milliseconds: I,
    options: E,
    hourOptions: re,
    isAM: q,
    isAMOptions: J,
    is24hr: i
  };
}
const ED = ["value"], ND = ["value", "disabled"], LD = {
  key: 1,
  class: "vc-base-sizer",
  "aria-hidden": "true"
}, xD = {
  inheritAttrs: !1
}, It = /* @__PURE__ */ ae({
  ...xD,
  __name: "BaseSelect",
  props: {
    options: null,
    modelValue: null,
    alignRight: { type: Boolean },
    alignLeft: { type: Boolean },
    showIcon: { type: Boolean },
    fitContent: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, r = m(() => {
      const n = t.options.find((a) => a.value === t.modelValue);
      return n == null ? void 0 : n.label;
    });
    return (n, a) => (_(), P("div", {
      class: Z(["vc-base-select", {
        "vc-fit-content": e.fitContent,
        "vc-has-icon": e.showIcon
      }])
    }, [
      F("select", dt(n.$attrs, {
        value: e.modelValue,
        class: ["vc-focus", {
          "vc-align-right": e.alignRight,
          "vc-align-left": e.alignLeft
        }],
        onChange: a[0] || (a[0] = (s) => n.$emit("update:modelValue", s.target.value))
      }), [
        (_(!0), P(ne, null, we(e.options, (s) => (_(), P("option", {
          key: s.value,
          value: s.value,
          disabled: s.disabled
        }, me(s.label), 9, ND))), 128))
      ], 16, ED),
      e.showIcon ? (_(), pe(ct, {
        key: 0,
        name: "ChevronDown",
        size: "18"
      })) : Q("", !0),
      e.fitContent ? (_(), P("div", LD, me(y(r)), 1)) : Q("", !0)
    ], 2));
  }
}), FD = {
  key: 0,
  class: "vc-time-header"
}, RD = { class: "vc-time-weekday" }, HD = { class: "vc-time-month" }, WD = { class: "vc-time-day" }, jD = { class: "vc-time-year" }, BD = { class: "vc-time-select-group" }, zD = /* @__PURE__ */ F("span", { class: "vc-time-colon" }, ":", -1), UD = /* @__PURE__ */ F("span", { class: "vc-time-colon" }, ":", -1), VD = /* @__PURE__ */ F("span", { class: "vc-time-decimal" }, ".", -1), La = /* @__PURE__ */ ae({
  __name: "TimePicker",
  props: {
    position: null
  },
  setup(e, { expose: t }) {
    const n = AD(e);
    t(n);
    const {
      locale: a,
      isValid: s,
      date: o,
      hours: i,
      minutes: u,
      seconds: c,
      milliseconds: d,
      options: f,
      hourOptions: v,
      isTimeMode: h,
      isAM: b,
      isAMOptions: Y,
      is24hr: M,
      showHeader: D,
      timeAccuracy: N
    } = n;
    return (B, A) => (_(), P("div", {
      class: Z(["vc-time-picker", [{ "vc-invalid": !y(s), "vc-attached": !y(h) }]])
    }, [
      x(De, { name: "time-header" }, {
        default: ee(() => [
          y(D) && y(o) ? (_(), P("div", FD, [
            F("span", RD, me(y(a).formatDate(y(o), "WWW")), 1),
            F("span", HD, me(y(a).formatDate(y(o), "MMM")), 1),
            F("span", WD, me(y(a).formatDate(y(o), "D")), 1),
            F("span", jD, me(y(a).formatDate(y(o), "YYYY")), 1)
          ])) : Q("", !0)
        ]),
        _: 1
      }),
      F("div", BD, [
        x(ct, {
          name: "Clock",
          size: "17"
        }),
        x(It, {
          modelValue: y(i),
          "onUpdate:modelValue": A[0] || (A[0] = (I) => Ct(i) ? i.value = I : null),
          modelModifiers: { number: !0 },
          options: y(v),
          class: "vc-time-select-hours",
          "align-right": ""
        }, null, 8, ["modelValue", "options"]),
        y(N) > 1 ? (_(), P(ne, { key: 0 }, [
          zD,
          x(It, {
            modelValue: y(u),
            "onUpdate:modelValue": A[1] || (A[1] = (I) => Ct(u) ? u.value = I : null),
            modelModifiers: { number: !0 },
            options: y(f).minutes,
            class: "vc-time-select-minutes",
            "align-left": y(N) === 2
          }, null, 8, ["modelValue", "options", "align-left"])
        ], 64)) : Q("", !0),
        y(N) > 2 ? (_(), P(ne, { key: 1 }, [
          UD,
          x(It, {
            modelValue: y(c),
            "onUpdate:modelValue": A[2] || (A[2] = (I) => Ct(c) ? c.value = I : null),
            modelModifiers: { number: !0 },
            options: y(f).seconds,
            class: "vc-time-select-seconds",
            "align-left": y(N) === 3
          }, null, 8, ["modelValue", "options", "align-left"])
        ], 64)) : Q("", !0),
        y(N) > 3 ? (_(), P(ne, { key: 2 }, [
          VD,
          x(It, {
            modelValue: y(d),
            "onUpdate:modelValue": A[3] || (A[3] = (I) => Ct(d) ? d.value = I : null),
            modelModifiers: { number: !0 },
            options: y(f).milliseconds,
            class: "vc-time-select-milliseconds",
            "align-left": ""
          }, null, 8, ["modelValue", "options"])
        ], 64)) : Q("", !0),
        y(M) ? Q("", !0) : (_(), pe(It, {
          key: 3,
          modelValue: y(b),
          "onUpdate:modelValue": A[4] || (A[4] = (I) => Ct(b) ? b.value = I : null),
          options: y(Y)
        }, null, 8, ["modelValue", "options"]))
      ])
    ], 2));
  }
}), oo = /* @__PURE__ */ ae({
  __name: "DatePickerBase",
  setup(e) {
    const {
      attributes: t,
      calendarRef: r,
      color: n,
      displayMode: a,
      isDateTimeMode: s,
      isTimeMode: o,
      isRange: i,
      onDayClick: u,
      onDayMouseEnter: c,
      onDayKeydown: d
    } = kn(), f = i.value ? [0, 1] : [0];
    return (v, h) => y(o) ? (_(), P("div", {
      key: 0,
      class: Z(`vc-container vc-bordered vc-${y(n)} vc-${y(a)}`)
    }, [
      (_(!0), P(ne, null, we(y(f), (b) => (_(), pe(La, {
        key: b,
        position: b
      }, null, 8, ["position"]))), 128))
    ], 2)) : (_(), pe(PD, {
      key: 1,
      attributes: y(t),
      ref_key: "calendarRef",
      ref: r,
      onDayclick: y(u),
      onDaymouseenter: y(c),
      onDaykeydown: y(d)
    }, {
      footer: ee(() => [
        y(s) ? (_(!0), P(ne, { key: 0 }, we(y(f), (b) => (_(), pe(La, {
          key: b,
          position: b
        }, null, 8, ["position"]))), 128)) : Q("", !0),
        x(De, { name: "dp-footer" })
      ]),
      _: 1
    }, 8, ["attributes", "onDayclick", "onDaymouseenter", "onDaykeydown"]));
  }
}), KD = {
  inheritAttrs: !1
}, GD = /* @__PURE__ */ ae({
  ...KD,
  __name: "DatePickerPopover",
  setup(e) {
    const {
      datePickerPopoverId: t,
      color: r,
      displayMode: n,
      popoverRef: a,
      onPopoverBeforeShow: s,
      onPopoverAfterShow: o,
      onPopoverBeforeHide: i,
      onPopoverAfterHide: u
    } = kn();
    return (c, d) => (_(), pe(Mn, {
      id: y(t),
      placement: "bottom-start",
      class: Z(`vc-date-picker-content vc-${y(r)} vc-${y(n)}`),
      ref_key: "popoverRef",
      ref: a,
      onBeforeShow: y(s),
      onAfterShow: y(o),
      onBeforeHide: y(i),
      onAfterHide: y(u)
    }, {
      default: ee(() => [
        x(oo, xt(jr(c.$attrs)), null, 16)
      ]),
      _: 1
    }, 8, ["id", "class", "onBeforeShow", "onAfterShow", "onBeforeHide", "onAfterHide"]));
  }
}), ZD = ae({
  inheritAttrs: !1,
  emits: CD,
  props: TD,
  components: { DatePickerBase: oo, DatePickerPopover: GD },
  setup(e, t) {
    const r = OD(e, t), n = tn(Ms(r, "calendarRef", "popoverRef"));
    return { ...r, slotCtx: n };
  }
});
function qD(e, t, r, n, a, s) {
  const o = Le("DatePickerPopover"), i = Le("DatePickerBase");
  return e.$slots.default ? (_(), P(ne, { key: 0 }, [
    Wt(e.$slots, "default", xt(jr(e.slotCtx))),
    x(o, xt(jr(e.$attrs)), null, 16)
  ], 64)) : (_(), pe(i, xt(dt({ key: 1 }, e.$attrs)), null, 16));
}
const QD = /* @__PURE__ */ Ve(ZD, [["render", qD]]);
export {
  PD as C,
  QD as D
};
//# sourceMappingURL=index-DQ1kEltI.mjs.map
